import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.home');
import { OnInit } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

interface HomeTag {
    name: string;
    axis?: string;
}

interface HomePdf {
    filename: string;
    url?: string;
}

interface HomeBook {
    id: string;
    hflibId?: string;
    title: string;
    author: string;
    publisher: string;
    publishedDate: string;
    publishedYear?: number;
    category: string;
    materialType: string;
    coverImage: string;
    coverFallbackImage?: string;
    coverAvailable: boolean;
    pdfAvailable: boolean;
    bodySearchAvailable: boolean;
    graphAvailable: boolean;
    bodyChunkCount: number;
    pdfCount: number;
    tags: HomeTag[];
    publicStatus: string;
    reviewStatus: string;
    pdfs: HomePdf[];
}

interface HomeCollection {
    id: string;
    title: string;
    description: string;
    materialCount: number;
    pdfCount: number;
    bodyIndexedCount: number;
    reviewStatus: string;
    publicStatus: string;
}

interface HomeCollectionStat {
    label: string;
    value: string;
}

interface HomeMetric {
    label: string;
    value: string;
    note: string;
    tone: string;
}

interface HomeEntry {
    id: string;
    icon: string;
    label: string;
    title: string;
    body: string;
    href: string;
    stat: string;
    tone: string;
}

interface HomeNavItem {
    id: string;
    label: string;
    href: string;
}

interface HomeFieldBundle {
    id: string;
    axisLabel: string;
    title: string;
    count: number;
    tags: string[];
    href: string;
}

interface HomeFlowStep {
    id: string;
    label: string;
    meta: string;
    href: string;
    icon: string;
}

interface FeaturedTopic {
    id: string;
    label: string;
    keywords: string[];
}

const TAG_AXES = {
    business: "공식 사업 축",
    issue: "역사현안 축",
    era: "시대 축",
    region: "지역·공간 축",
    relation: "관계사·국제질서 축",
    material: "자료 성격 축",
    purpose: "업무 목적 축",
    state: "공개·검수 상태 축",
};

const AXIS_LABELS: any = {
    "공식 사업 축": "공식 사업",
    "역사현안 축": "역사현안",
    "시대 축": "시대",
    "지역·공간 축": "지역·공간",
    "관계사·국제질서 축": "관계사·국제질서",
    "자료 성격 축": "자료 성격",
    "업무 목적 축": "업무 목적",
    "공개·검수 상태 축": "검수·공개",
    "검수·공개 상태 축": "검수·공개",
};

const COLLECTION_ORDER = [
    "dokdo",
    "balhae",
    "goguryeo",
    "northeast-project",
    "japanese-intrusion",
    "comfort-women",
    "korea-japan-talks",
    "gando-border",
];

const COLLECTION_TITLES: any = {
    dokdo: "독도",
    balhae: "발해",
    goguryeo: "고구려",
    "northeast-project": "동북공정",
    "japanese-intrusion": "일제침탈",
    "comfort-women": "위안부",
    "korea-japan-talks": "한일회담",
    "gando-border": "간도",
};

const COLLECTION_DESCRIPTIONS: any = {
    dokdo: "독도 영유권과 동해 표기 자료",
    balhae: "발해와 유적·고고학 자료",
    goguryeo: "고구려와 유적·비문 자료",
    "northeast-project": "중국 역사서술 쟁점 자료",
    "japanese-intrusion": "식민지 지배와 침탈 자료",
    "comfort-women": "위안부 관련 자료",
    "korea-japan-talks": "한일회담과 청구권 자료",
    "gando-border": "간도와 국경 인식 자료",
};

const FEATURED_BOOK_LIMIT = 8;
const RECENT_BOOK_LIMIT = 8;
const FEATURED_TARGET_TOPICS: FeaturedTopic[] = [
    { id: "dokdo", label: "독도", keywords: ["독도", "동해", "울릉", "영유권", "dokdo", "takeshima", "liancourt"] },
    { id: "comfort-women", label: "위안부", keywords: ["위안부", "위안소", "성노예", "comfort women", "woman victims"] },
    { id: "northeast-project", label: "동북공정", keywords: ["동북공정", "중국 역사", "중국사 인식", "중국의 역사만들기", "동북아 역사 문제"] },
    { id: "goguryeo", label: "고구려", keywords: ["고구려", "goguryeo", "koguryo", "高句麗", "광개토", "충주고구려비", "고분벽화", "산성"] },
    { id: "balhae", label: "발해", keywords: ["발해", "balhae", "parhae", "渤海", "크라스키노", "연해주", "발해성"] },
];

@Component({
    selector: 'wiz-page-home',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.home/view.scss */
:host {
  --design-bg: #FFFFFF;
  --design-surface: #FFFFFF;
  --design-surface-muted: rgba(30, 30, 30, 0.32);
  --design-surface-tinted: rgba(255, 255, 255, 0.72);
  --design-text: #1F1F1F;
  --design-text-secondary: #666666;
  --design-text-muted: #8A8A8A;
  --design-border: rgba(30, 30, 30, 0.18);
  --design-border-strong: rgba(30, 30, 30, 0.28);
  --design-accent: #1F1F1F;
  --design-accent-strong: #111111;
  --design-accent-wash: rgba(30, 30, 30, 0.08);
  --design-green: #5E6676;
  --design-green-wash: rgba(94, 102, 118, 0.11);
  --design-amber: #687086;
  --design-amber-wash: rgba(104, 112, 134, 0.18);
  --design-rose: #666666;
  --design-rose-wash: rgba(102, 102, 102, 0.12);
  --design-focus-ring: 0 0 0 3px rgba(31, 31, 31, 0.16);
  --design-shadow: 0 1px 2px rgba(30, 30, 30, 0.08);
  --design-shadow-strong: 0 10px 26px rgba(30, 30, 30, 0.12);
  display: block;
  min-height: 100vh;
  background: var(--design-bg);
  color: var(--design-text);
  font-family: SUIT, Arial, sans-serif;
}

.home-page {
  width: min(1440px, 100%);
  margin: 0 auto;
  padding: 20px 28px 56px;
}

.home-header,
.brand-link,
.primary-nav,
.home-auth,
.header-link,
.search-box,
.search-actions,
.topic-strip,
.section-heading,
.featured-layout,
.graph-band,
.graph-action,
.flow-list,
.badge-row,
.bundle-tags {
  display: flex;
  align-items: center;
}

.home-header {
  justify-content: space-between;
  gap: 18px;
  min-height: 48px;
  margin-bottom: 18px;
}

.brand-link {
  flex: 0 0 auto;
  min-width: 214px;
  min-height: 44px;
  color: var(--design-text);
  text-decoration: none;
}

.brand-logo {
  display: block;
  width: auto;
  height: 38px;
  max-width: min(220px, 56vw);
  object-fit: contain;
}

.brand-symbol {
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--design-border-strong);
  border-radius: 8px;
  background: var(--design-surface-tinted);
  color: var(--design-accent-strong);
  font-size: 13px;
  font-weight: 900;
}

.brand-copy {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.brand-copy strong {
  overflow-wrap: anywhere;
  font-size: 14px;
  font-weight: 900;
  line-height: 1.2;
}

.brand-copy em {
  color: var(--design-text-secondary);
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
  line-height: 1.2;
}

.primary-nav {
  flex: 1;
  justify-content: center;
  gap: 4px;
  min-width: 0;
}

.primary-nav a {
  min-height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  padding: 0 12px;
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 850;
  text-decoration: none;
  white-space: nowrap;
}

.home-auth {
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
}

.home-profile {
  display: grid;
  gap: 2px;
  padding: 8px 10px;
  border: 1px solid var(--design-border);
  border-radius: 8px;
  background: var(--design-surface);
  text-align: right;
}

.home-profile strong {
  font-size: 13px;
  font-weight: 850;
}

.home-profile span {
  color: var(--design-text-secondary);
  font-size: 12px;
  font-weight: 700;
}

.header-link {
  justify-content: center;
  gap: 7px;
  min-height: 38px;
  border: 1px solid var(--design-border-strong);
  border-radius: 8px;
  padding: 0 12px;
  background: var(--design-surface);
  color: var(--design-accent-strong);
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;
}

.search-band {
  display: grid;
  grid-template-columns: minmax(360px, 0.95fr) minmax(520px, 1.05fr);
  gap: 20px 26px;
  align-items: start;
  border-top: 1px solid var(--design-border);
  border-bottom: 1px solid var(--design-border);
  padding: 28px 0 24px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.46), rgba(255, 255, 255, 0));
}

.search-copy {
  min-width: 0;
  padding-top: 4px;
}

.eyebrow {
  margin: 0 0 8px;
  color: var(--design-accent-strong);
  font-size: 13px;
  font-weight: 850;
}

h1,
h2,
h3 {
  margin: 0;
  color: var(--design-text);
  font-weight: 850;
  letter-spacing: 0;
  word-break: keep-all;
  overflow-wrap: break-word;
}

h1 {
  max-width: 720px;
  font-size: 35px;
  line-height: 1.16;
}

h2 {
  font-size: 23px;
  line-height: 1.25;
}

h3 {
  font-size: 18px;
  line-height: 1.3;
}

.search-copy p:last-child,
.graph-copy p:last-child {
  margin: 13px 0 0;
  color: var(--design-text-secondary);
  font-size: 15px;
  line-height: 1.58;
}

.home-search {
  display: grid;
  align-content: center;
  gap: 12px;
  min-width: 0;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.search-box {
  gap: 10px;
  min-height: 74px;
  border: 2px solid var(--design-accent);
  border-radius: 8px;
  padding: 9px 10px 9px 18px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: var(--design-shadow-strong);
}

.search-box > i {
  flex: 0 0 auto;
  color: var(--design-accent-strong);
  font-size: 20px;
}

.search-box input {
  min-width: 0;
  flex: 1;
  border: 0;
  outline: none;
  background: transparent;
  color: var(--design-text);
  font-size: 20px;
  font-weight: 800;
}

.search-box button,
.graph-action {
  justify-content: center;
  gap: 8px;
  min-height: 50px;
  border: 0;
  border-radius: 8px;
  padding: 0 18px;
  background: var(--design-accent);
  color: #fff;
  font-size: 15px;
  font-weight: 850;
  text-decoration: none;
  white-space: nowrap;
}

.topic-strip {
  flex-wrap: wrap;
  gap: 8px;
}

.topic-strip > span {
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 850;
}

.topic-strip a,
.badge-row i,
.bundle-tags i {
  border: 1px solid var(--design-border);
  border-radius: 8px;
  background: var(--design-surface);
  color: var(--design-text-secondary);
  font-style: normal;
  text-decoration: none;
}

.topic-strip a {
  padding: 7px 10px;
  font-size: 13px;
  font-weight: 800;
}

.search-actions {
  flex-wrap: wrap;
  gap: 8px;
}

.secondary-action {
  min-height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid var(--design-border-strong);
  border-radius: 8px;
  padding: 0 12px;
  background: var(--design-surface);
  color: var(--design-accent-strong);
  font-size: 13px;
  font-weight: 850;
  text-decoration: none;
}

.entry-grid,
.metric-strip,
.collection-grid,
.recommended-grid,
.recent-list,
.bundle-grid {
  display: grid;
  gap: 12px;
}

.entry-grid {
  grid-column: 1/-1;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.entry-card,
.metric-card,
.collection-card,
.resource-card,
.recent-row,
.bundle-card,
.flow-step {
  min-width: 0;
  border: 1px solid var(--design-border);
  border-radius: 8px;
  background: var(--design-surface);
  color: var(--design-text);
  text-decoration: none;
  box-shadow: var(--design-shadow);
}

.entry-card {
  display: grid;
  grid-template-rows: auto auto auto 1fr auto;
  gap: 8px;
  min-height: 142px;
  padding: 15px;
  border-top-width: 3px;
}

.entry-icon {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: var(--design-accent-wash);
  color: var(--design-accent-strong);
}

.entry-label,
.metric-card small,
.resource-body small,
.collection-meta small,
.recent-row span,
.bundle-kicker,
.flow-step em {
  color: var(--design-text-secondary);
  font-size: 12px;
  font-weight: 800;
}

.entry-card strong,
.collection-card strong,
.resource-card strong,
.recent-row strong,
.bundle-card strong,
.flow-step strong {
  overflow-wrap: anywhere;
  font-size: 15px;
  font-weight: 850;
  line-height: 1.35;
}

.entry-card p {
  margin: 0;
  color: var(--design-text-secondary);
  font-size: 13px;
  line-height: 1.42;
}

.entry-card em,
.metric-card em,
.bundle-card em {
  color: var(--design-text-muted);
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
  line-height: 1.35;
}

.entry-card em {
  justify-self: start;
  border-radius: 8px;
  padding: 5px 8px;
  background: var(--design-surface-muted);
  color: var(--design-text);
}

.tone-blue {
  border-top-color: var(--design-accent);
}

.tone-green {
  border-top-color: var(--design-green);
}

.tone-amber {
  border-top-color: var(--design-amber);
}

.tone-rose {
  border-top-color: var(--design-rose);
}

.metric-strip {
  grid-column: 1/-1;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.metric-card {
  display: grid;
  gap: 4px;
  border-top-width: 3px;
  padding: 13px 14px;
}

.metric-card strong {
  font-size: 23px;
  line-height: 1;
  font-weight: 900;
}

.status-panel {
  margin-top: 12px;
  border: 1px solid var(--design-border);
  border-radius: 8px;
  padding: 11px 13px;
  background: var(--design-surface);
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 800;
}

.error-text {
  color: #B42318;
}

.content-band {
  margin-top: 24px;
  border-top: 1px solid var(--design-border);
  padding-top: 20px;
}

.section-heading {
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 14px;
}

.section-heading a {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: var(--design-accent-strong);
  font-size: 13px;
  font-weight: 850;
  text-decoration: none;
  white-space: nowrap;
}

.collection-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.collection-card {
  display: grid;
  grid-template-rows: 1fr auto;
  gap: 12px;
  min-height: 132px;
  padding: 15px;
}

.collection-title,
.collection-meta,
.resource-body,
.rail-heading,
.bundle-card,
.flow-step {
  display: grid;
}

.collection-title {
  gap: 6px;
}

.collection-title em {
  overflow-wrap: anywhere;
  color: var(--design-text-secondary);
  font-size: 13px;
  font-style: normal;
  line-height: 1.42;
}

.collection-meta {
  gap: 4px;
}

.featured-layout {
  align-items: stretch;
  gap: 18px;
}

.recommended-grid {
  flex: 1;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.resource-card {
  display: grid;
  grid-template-columns: 100px minmax(0, 1fr);
  gap: 14px;
  padding: 12px;
}

.cover-frame {
  aspect-ratio: 0.7;
  width: 100px;
  border: 1px solid var(--design-border);
  border-radius: 8px;
  overflow: hidden;
  background: var(--design-surface-muted);
}

.cover-frame img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.topic-cover {
  width: 100px;
  aspect-ratio: 0.7;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--design-border);
  border-radius: 8px;
  background: var(--design-accent-wash);
  color: var(--design-accent-strong);
  font-size: 26px;
}

.resource-body {
  gap: 6px;
  align-content: start;
}

.resource-body em {
  color: var(--design-text-secondary);
  font-size: 13px;
  font-style: normal;
  line-height: 1.4;
}

.badge-row,
.bundle-tags {
  flex-wrap: wrap;
  gap: 6px;
}

.badge-row i,
.bundle-tags i {
  padding: 4px 7px;
  font-size: 11px;
  font-weight: 850;
}

.recent-rail {
  width: min(360px, 34%);
  border-left: 1px solid var(--design-border);
  padding-left: 18px;
}

.rail-heading {
  gap: 2px;
  margin-bottom: 12px;
}

.recent-row {
  display: grid;
  gap: 4px;
  padding: 11px 12px;
}

.bundle-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.bundle-card {
  gap: 8px;
  min-height: 146px;
  padding: 15px;
  border-top: 3px solid var(--design-border-strong);
}

.bundle-card em {
  justify-self: start;
  color: var(--design-accent-strong);
}

.empty-state {
  border: 1px dashed var(--design-border-strong);
  border-radius: 8px;
  padding: 18px;
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 800;
}

.graph-band {
  justify-content: space-between;
  align-items: stretch;
  gap: 18px;
  margin-top: 24px;
  border-top: 1px solid var(--design-border);
  padding-top: 20px;
}

.graph-copy {
  min-width: 230px;
  max-width: 360px;
}

.flow-list {
  flex: 1;
  gap: 10px;
}

.flow-step {
  min-height: 112px;
  flex: 1;
  align-content: start;
  gap: 7px;
  padding: 13px;
}

.flow-step span {
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: var(--design-accent-wash);
  color: var(--design-accent-strong);
}

.graph-action {
  align-self: center;
  min-width: 170px;
}

.header-link:hover,
.header-link:focus-visible,
.primary-nav a:hover,
.primary-nav a:focus-visible,
.topic-strip a:hover,
.topic-strip a:focus-visible,
.secondary-action:hover,
.secondary-action:focus-visible,
.entry-card:hover,
.entry-card:focus-visible,
.collection-card:hover,
.collection-card:focus-visible,
.resource-card:hover,
.resource-card:focus-visible,
.recent-row:hover,
.recent-row:focus-visible,
.bundle-card:hover,
.bundle-card:focus-visible,
.flow-step:hover,
.flow-step:focus-visible,
.section-heading a:hover,
.section-heading a:focus-visible {
  border-color: var(--design-accent);
  box-shadow: var(--design-focus-ring);
}

.primary-nav a:hover,
.primary-nav a:focus-visible,
.section-heading a:hover,
.section-heading a:focus-visible {
  color: var(--design-accent-strong);
}

.search-box:focus-within {
  border-color: var(--design-accent);
  box-shadow: var(--design-focus-ring), var(--design-shadow-strong);
}

.search-box button:hover,
.search-box button:focus-visible,
.graph-action:hover,
.graph-action:focus-visible {
  background: var(--design-accent-strong);
}

@media (max-width: 1180px) {
  .home-header {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .primary-nav {
    order: 3;
    width: 100%;
    justify-content: flex-start;
    overflow-x: auto;
    padding-bottom: 2px;
  }
  .search-band {
    grid-template-columns: 1fr;
  }
  .entry-grid,
  .collection-grid,
  .bundle-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .featured-layout,
  .graph-band {
    flex-direction: column;
  }
  .recent-rail {
    width: 100%;
    border-left: 0;
    border-top: 1px solid var(--design-border);
    padding: 16px 0 0;
  }
  .flow-list {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .graph-action {
    align-self: flex-start;
  }
}
@media (max-width: 820px) {
  .home-page {
    padding: 16px 14px 40px;
  }
  .brand-link {
    min-width: 0;
  }
  .brand-logo {
    height: 34px;
    max-width: min(210px, 62vw);
  }
  .home-auth {
    width: 100%;
    justify-content: flex-start;
  }
  h1 {
    font-size: 29px;
  }
  h2 {
    font-size: 20px;
  }
  .search-band {
    padding-top: 20px;
  }
  .search-box {
    align-items: stretch;
    flex-wrap: wrap;
    min-height: 0;
  }
  .search-box input {
    min-height: 36px;
    flex-basis: calc(100% - 34px);
    font-size: 17px;
  }
  .search-box button {
    width: 100%;
  }
  .entry-grid,
  .metric-strip,
  .collection-grid,
  .recommended-grid,
  .bundle-grid,
  .flow-list {
    grid-template-columns: 1fr;
  }
  .resource-card {
    grid-template-columns: 84px minmax(0, 1fr);
  }
  .cover-frame {
    width: 84px;
  }
  .topic-cover {
    width: 84px;
  }
  .section-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .graph-action {
    width: 100%;
  }
}
/* Step 94: final public knowledge-platform polish. */
:host {
  --design-bg: #FFFFFF;
  --design-surface: #FFFFFF;
  --design-surface-muted: rgba(30, 30, 30, 0.32);
  --design-text: #1F1F1F;
  --design-text-secondary: #666666;
  --design-text-muted: #8A8A8A;
  --design-border: rgba(30, 30, 30, 0.18);
  --design-border-strong: rgba(30, 30, 30, 0.28);
  --design-accent: #1F1F1F;
  --design-accent-strong: #111111;
  --design-accent-wash: rgba(30, 30, 30, 0.08);
  --design-green: #5E6676;
  --design-green-wash: rgba(94, 102, 118, 0.11);
  --design-amber: #687086;
  --design-amber-wash: rgba(104, 112, 134, 0.18);
  --design-rose: #666666;
  --design-rose-wash: rgba(102, 102, 102, 0.12);
  --design-focus-ring: 0 0 0 3px rgba(31, 31, 31, 0.16);
  --design-shadow: 0 1px 2px rgba(30, 30, 30, 0.08);
  --design-shadow-strong: 0 10px 26px rgba(30, 30, 30, 0.12);
  font-family: "Pretendard", "Noto Sans KR", system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
}

.home-page {
  width: min(1320px, 100%);
  padding: 22px 28px 60px;
}

.home-header {
  margin-bottom: 18px;
}

.brand-symbol,
.header-link,
.home-profile,
.entry-card,
.metric-card,
.collection-card,
.resource-card,
.recent-row,
.bundle-card,
.flow-step {
  border-color: var(--design-border);
  background: var(--design-surface);
  box-shadow: var(--design-shadow);
}

.brand-symbol {
  color: var(--design-accent-strong);
}

.primary-nav a,
.header-link,
.secondary-action,
.section-heading a,
.graph-action {
  border-radius: 8px;
}

.search-band {
  grid-template-columns: minmax(320px, 0.9fr) minmax(520px, 1.1fr);
  gap: 22px 28px;
  padding: 30px;
  border: 1px solid var(--design-border);
  border-radius: 8px;
  background: var(--design-surface);
  box-shadow: var(--design-shadow-strong);
}

.search-copy {
  padding-top: 2px;
}

h1 {
  max-width: 680px;
  font-size: 36px;
  line-height: 1.18;
}

h2 {
  font-size: 24px;
}

.search-copy p:last-child,
.graph-copy p:last-child {
  max-width: 680px;
  font-size: 15.5px;
}

.search-box {
  min-height: 64px;
  border: 1px solid var(--design-border-strong);
  background: rgba(255, 255, 255, 0.94);
  box-shadow: none;
}

.search-box:focus-within {
  border-color: var(--design-accent);
  box-shadow: var(--design-focus-ring);
}

.search-box input {
  font-size: 18px;
  font-weight: 760;
}

.search-box button,
.graph-action {
  min-height: 46px;
  background: var(--design-accent-strong);
}

.search-box button:hover,
.search-box button:focus-visible,
.graph-action:hover,
.graph-action:focus-visible {
  background: var(--design-accent);
}

.topic-strip a,
.secondary-action,
.header-link,
.badge-row i,
.bundle-tags i {
  border-color: var(--design-border-strong);
  background: #FFFFFF;
  color: var(--design-accent-strong);
}

.entry-grid {
  gap: 14px;
}

.entry-card {
  min-height: 148px;
  border-top-width: 3px;
  padding: 16px;
}

.entry-card p,
.collection-title em,
.resource-body em {
  color: var(--design-text-secondary);
}

.tone-blue {
  border-top-color: var(--design-accent);
}

.tone-green {
  border-top-color: var(--design-green);
}

.tone-amber {
  border-top-color: var(--design-amber);
}

.tone-rose {
  border-top-color: var(--design-rose);
}

.entry-icon,
.flow-step span,
.topic-cover {
  background: var(--design-accent-wash);
  color: var(--design-accent-strong);
}

.metric-strip {
  gap: 12px;
}

.metric-card {
  min-height: 94px;
  padding: 14px;
}

.content-band {
  margin-top: 26px;
  padding-top: 24px;
  border-top-color: var(--design-border);
}

.section-heading {
  margin-bottom: 16px;
}

.collection-grid,
.recommended-grid,
.bundle-grid {
  gap: 14px;
}

.collection-card,
.bundle-card {
  min-height: 138px;
  padding: 16px;
}

.resource-card {
  grid-template-columns: 96px minmax(0, 1fr);
  padding: 13px;
}

.cover-frame,
.topic-cover {
  width: 96px;
  border-color: var(--design-border);
  background: var(--design-surface-muted);
}

.recent-rail {
  border-left-color: var(--design-border);
}

.graph-band {
  align-items: stretch;
  padding: 22px;
  border: 1px solid var(--design-border);
  border-radius: 8px;
  background: var(--design-surface);
  box-shadow: var(--design-shadow);
}

.flow-step {
  min-height: 108px;
}

.header-link:hover,
.header-link:focus-visible,
.primary-nav a:hover,
.primary-nav a:focus-visible,
.topic-strip a:hover,
.topic-strip a:focus-visible,
.secondary-action:hover,
.secondary-action:focus-visible,
.entry-card:hover,
.entry-card:focus-visible,
.collection-card:hover,
.collection-card:focus-visible,
.resource-card:hover,
.resource-card:focus-visible,
.recent-row:hover,
.recent-row:focus-visible,
.bundle-card:hover,
.bundle-card:focus-visible,
.flow-step:hover,
.flow-step:focus-visible,
.section-heading a:hover,
.section-heading a:focus-visible {
  border-color: var(--design-border-strong);
  box-shadow: var(--design-focus-ring);
}

@media (max-width: 1180px) {
  .search-band {
    grid-template-columns: 1fr;
    padding: 24px;
  }
}
@media (max-width: 820px) {
  .home-page {
    padding: 16px 14px 42px;
  }
  .search-band {
    padding: 18px;
  }
  h1 {
    font-size: 29px;
  }
  .search-box input {
    flex-basis: calc(100% - 34px);
    font-size: 17px;
  }
  .resource-card {
    grid-template-columns: 84px minmax(0, 1fr);
  }
  .cover-frame,
  .topic-cover {
    width: 84px;
  }
}
/* Review 97: shared public entry token layer. */
.entry-card,
.metric-card,
.collection-card,
.resource-card,
.recent-row,
.bundle-card,
.flow-step,
.home-profile,
.brand-symbol {
  border-color: var(--design-border);
  background: rgba(255, 255, 255, 0.92);
  box-shadow: var(--design-shadow);
}

.search-band,
.graph-band,
.content-band {
  border-color: var(--design-border);
}

.search-box {
  border-color: var(--design-accent);
  background: rgba(255, 255, 255, 0.94);
}

.search-box button,
.graph-action {
  border-color: var(--design-accent);
  background: var(--design-accent);
  color: #FFFFFF;
}

.search-box button:hover,
.search-box button:focus-visible,
.graph-action:hover,
.graph-action:focus-visible {
  background: var(--design-accent-strong);
}

.secondary-action,
.header-link,
.topic-strip a,
.section-heading a {
  border-color: var(--design-border-strong);
  background: #FFFFFF;
  color: var(--design-accent);
}

.secondary-action:hover,
.secondary-action:focus-visible,
.header-link:hover,
.header-link:focus-visible,
.topic-strip a:hover,
.topic-strip a:focus-visible,
.section-heading a:hover,
.section-heading a:focus-visible {
  border-color: var(--design-accent);
  background: var(--design-accent-wash);
  color: var(--design-accent-strong);
}

.badge-row i,
.bundle-tags i,
.entry-card em,
.resource-card .badge-row i {
  border-color: var(--design-border);
  background: var(--design-surface-tinted, rgba(255, 255, 255, 0.72));
  color: var(--design-text-secondary);
}

/* Review 98: first screen search hierarchy and charcoal CTA system. */
:host {
  --home-cta: #1F1F1F;
  --home-cta-hover: #2B2B2B;
  --home-olive: #5E6676;
  --home-cream-chip: rgba(255, 255, 255, 0.82);
  --home-olive-chip: rgba(94, 102, 118, 0.12);
  --home-beige-chip: rgba(30, 30, 30, 0.34);
  --home-search-shadow: 0 16px 38px rgba(31, 31, 31, 0.16);
}

.home-header {
  margin-bottom: 16px;
}

.header-link {
  border-color: rgba(31, 31, 31, 0.42);
  background: rgba(255, 255, 255, 0.66);
  color: var(--home-cta);
  box-shadow: none;
}

.home-auth .header-link:last-child {
  border-color: var(--home-cta);
  background: var(--home-cta);
  color: #FFFFFF;
}

.home-auth .header-link:hover,
.home-auth .header-link:focus-visible {
  border-color: var(--home-cta-hover);
  background: var(--home-cta-hover);
  color: #FFFFFF;
}

.search-band {
  grid-template-columns: minmax(320px, 0.82fr) minmax(560px, 1.18fr);
  gap: 28px 34px;
  align-items: center;
  padding: 34px;
  border-color: rgba(30, 30, 30, 0.28);
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.94), rgba(255, 255, 255, 0.78) 58%, rgba(30, 30, 30, 0.3)), var(--design-surface);
  box-shadow: 0 16px 40px rgba(30, 30, 30, 0.13);
}

.search-copy {
  display: grid;
  gap: 12px;
  padding-top: 0;
}

.search-copy .eyebrow {
  margin-bottom: 0;
  color: var(--home-cta);
}

h1 {
  max-width: 580px;
  font-size: 40px;
  line-height: 1.14;
}

.search-copy p:last-child {
  max-width: 560px;
  margin: 0;
  color: #666666;
  font-size: 16px;
  line-height: 1.58;
}

.home-search {
  gap: 14px;
  align-self: center;
}

.search-box {
  min-height: 78px;
  border: 2px solid var(--home-cta);
  padding: 10px 11px 10px 20px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: var(--home-search-shadow), inset 0 0 0 1px rgba(94, 102, 118, 0.08);
}

.search-box > i {
  color: var(--home-cta);
  font-size: 22px;
}

.search-box input {
  color: var(--home-cta-hover);
  font-size: 20px;
  font-weight: 850;
}

.search-box input::placeholder {
  color: rgba(30, 30, 30, 0.58);
  font-weight: 750;
}

.search-box:focus-within {
  border-color: var(--home-olive);
  background: #FFFFFF;
  box-shadow: 0 0 0 4px rgba(94, 102, 118, 0.18), var(--home-search-shadow);
}

.search-box button {
  min-height: 54px;
  border: 1px solid var(--home-cta);
  padding: 0 24px;
  background: var(--home-cta);
  color: #FFFFFF;
  font-size: 16px;
  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.12);
}

.search-box button:hover,
.search-box button:focus-visible {
  border-color: var(--home-cta-hover);
  background: var(--home-cta-hover);
}

.topic-strip {
  gap: 9px;
}

.topic-strip > span {
  color: var(--home-cta);
  font-weight: 900;
}

.topic-strip a {
  border-color: rgba(30, 30, 30, 0.22);
  background: var(--home-cream-chip);
  color: var(--home-cta);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.38);
}

.topic-strip a:nth-of-type(3n + 2) {
  background: var(--home-olive-chip);
}

.topic-strip a:nth-of-type(3n) {
  background: var(--home-beige-chip);
}

.topic-strip a:hover,
.topic-strip a:focus-visible {
  border-color: var(--home-olive);
  background: rgba(94, 102, 118, 0.16);
  color: var(--home-cta-hover);
}

.secondary-action {
  border-color: rgba(30, 30, 30, 0.3);
  background: rgba(255, 255, 255, 0.78);
  color: var(--home-cta);
}

.entry-grid {
  margin-top: 2px;
}

@media (max-width: 1180px) {
  .search-band {
    grid-template-columns: 1fr;
    gap: 22px;
    padding: 28px;
  }
  h1 {
    max-width: 720px;
  }
}
@media (max-width: 820px) {
  .home-header {
    margin-bottom: 14px;
  }
  .search-band {
    gap: 18px;
    padding: 20px;
  }
  h1 {
    font-size: 30px;
    line-height: 1.18;
  }
  .search-copy {
    gap: 10px;
  }
  .search-copy p:last-child {
    font-size: 14.5px;
  }
  .search-box {
    min-height: 0;
    padding: 12px;
  }
  .search-box input {
    min-height: 40px;
    font-size: 17px;
  }
  .search-box button {
    min-height: 50px;
    width: 100%;
  }
  .topic-strip a {
    padding: 7px 9px;
  }
}
/* Review 99: first-screen action cards and metric card hierarchy. */
:host {
  --home-hover-shadow: 0 14px 30px rgba(31, 31, 31, 0.14);
  --home-tone-cream-bg: rgba(255, 255, 255, 0.14);
  --home-tone-olive-bg: rgba(94, 102, 118, 0.10);
  --home-tone-beige-bg: rgba(30, 30, 30, 0.13);
  --home-tone-charcoal-bg: rgba(30, 30, 30, 0.08);
  --home-tone-clay-bg: rgba(104, 112, 134, 0.12);
  --home-tone-bluegrey-bg: rgba(56, 80, 107, 0.10);
  --home-bluegrey: var(--design-source, #38506B);
}

.entry-card,
.metric-card {
  --tone-accent: var(--design-accent);
  --tone-border: var(--design-border-strong);
  --tone-card-bg: var(--home-tone-cream-bg);
  --tone-icon-bg: rgba(255, 255, 255, 0.52);
  --tone-pill-bg: rgba(255, 255, 255, 0.7);
  border-color: var(--tone-border);
  border-top-width: 1px;
  background: linear-gradient(135deg, var(--tone-card-bg), rgba(255, 255, 255, 0.86) 62%, rgba(255, 255, 255, 0.96)), var(--design-surface);
  box-shadow: 0 1px 2px rgba(31, 31, 31, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.72);
}

.entry-card.tone-cream,
.metric-card.tone-cream {
  --tone-accent: var(--home-cta);
  --tone-border: rgba(30, 30, 30, 0.25);
  --tone-card-bg: var(--home-tone-cream-bg);
  --tone-icon-bg: rgba(255, 255, 255, 0.76);
  --tone-pill-bg: rgba(255, 255, 255, 0.82);
}

.entry-card.tone-olive,
.metric-card.tone-olive {
  --tone-accent: var(--design-green);
  --tone-border: rgba(94, 102, 118, 0.28);
  --tone-card-bg: var(--home-tone-olive-bg);
  --tone-icon-bg: rgba(94, 102, 118, 0.14);
  --tone-pill-bg: rgba(94, 102, 118, 0.12);
}

.entry-card.tone-beige,
.metric-card.tone-beige {
  --tone-accent: var(--design-rose);
  --tone-border: rgba(102, 102, 102, 0.22);
  --tone-card-bg: var(--home-tone-beige-bg);
  --tone-icon-bg: rgba(30, 30, 30, 0.34);
  --tone-pill-bg: rgba(30, 30, 30, 0.4);
}

.entry-card.tone-charcoal,
.metric-card.tone-charcoal {
  --tone-accent: var(--home-cta);
  --tone-border: rgba(31, 31, 31, 0.32);
  --tone-card-bg: var(--home-tone-charcoal-bg);
  --tone-icon-bg: rgba(31, 31, 31, 0.14);
  --tone-pill-bg: rgba(30, 30, 30, 0.1);
}

.entry-card.tone-clay,
.metric-card.tone-clay {
  --tone-accent: var(--design-rose);
  --tone-border: rgba(102, 102, 102, 0.24);
  --tone-card-bg: var(--home-tone-clay-bg);
  --tone-icon-bg: rgba(104, 112, 134, 0.24);
  --tone-pill-bg: rgba(104, 112, 134, 0.22);
}

.entry-card.tone-bluegrey,
.metric-card.tone-bluegrey {
  --tone-accent: var(--home-bluegrey);
  --tone-border: rgba(56, 80, 107, 0.25);
  --tone-card-bg: var(--home-tone-bluegrey-bg);
  --tone-icon-bg: rgba(56, 80, 107, 0.15);
  --tone-pill-bg: rgba(56, 80, 107, 0.12);
}

.entry-card {
  min-height: 158px;
  gap: 9px;
  padding: 17px;
  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.entry-card:hover,
.entry-card:focus-visible {
  transform: translateY(-3px);
  border-color: var(--tone-accent);
  background: linear-gradient(135deg, var(--tone-card-bg), rgba(255, 255, 255, 0.8) 58%, rgba(255, 255, 255, 0.96)), var(--design-surface);
  box-shadow: var(--home-hover-shadow);
}

.entry-icon {
  width: 42px;
  height: 42px;
  border: 1px solid var(--tone-border);
  background: var(--tone-icon-bg);
  color: var(--tone-accent);
  transition: transform 160ms ease, background 160ms ease;
}

.entry-card:hover .entry-icon,
.entry-card:focus-visible .entry-icon {
  transform: translateY(-1px);
  background: var(--tone-pill-bg);
}

.entry-label {
  color: var(--tone-accent);
  font-weight: 900;
}

.entry-card strong {
  color: var(--design-text);
  font-size: 16px;
  font-weight: 900;
}

.entry-card p {
  color: var(--design-text-secondary);
  font-weight: 700;
}

.entry-card em {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid var(--tone-border);
  background: var(--tone-pill-bg);
  color: var(--tone-accent);
  font-weight: 900;
}

.entry-card em::after {
  content: "";
  width: 6px;
  height: 6px;
  border-top: 2px solid currentColor;
  border-right: 2px solid currentColor;
  transform: rotate(45deg);
}

.metric-card {
  min-height: 98px;
  gap: 6px;
  padding: 15px;
}

.metric-card small {
  color: var(--tone-accent);
  font-weight: 900;
}

.metric-card strong {
  color: var(--design-text);
  font-size: 24px;
}

.metric-card em {
  color: var(--design-text-secondary);
  font-weight: 800;
}

/* Review 100: topic collection and field card hierarchy. */
:host {
  --home-topic-bg: linear-gradient(135deg, rgba(255, 255, 255, 0.68), rgba(30, 30, 30, 0.24) 62%, rgba(255, 255, 255, 0.72));
  --home-topic-border: rgba(30, 30, 30, 0.22);
  --home-chip-border: rgba(30, 30, 30, 0.2);
  --home-chip-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.58);
}

.section-heading > div {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.section-description {
  max-width: 680px;
  margin: 2px 0 0;
  color: #666666;
  font-size: 14px;
  font-weight: 720;
  line-height: 1.52;
}

.topic-band {
  margin-top: 28px;
  border: 1px solid var(--home-topic-border);
  border-radius: 8px;
  padding: 24px;
  background: var(--home-topic-bg);
  box-shadow: 0 12px 32px rgba(30, 30, 30, 0.1);
}

.topic-band .section-heading {
  margin-bottom: 18px;
}

.topic-band .section-heading a {
  min-height: 36px;
  border: 1px solid var(--home-cta);
  border-radius: 8px;
  padding: 0 13px;
  background: var(--home-cta);
  color: #FFFFFF;
}

.topic-band .section-heading a:hover,
.topic-band .section-heading a:focus-visible {
  border-color: var(--home-cta-hover);
  background: var(--home-cta-hover);
  color: #FFFFFF;
}

.collection-card {
  --collection-accent: var(--home-cta);
  --collection-border: rgba(30, 30, 30, 0.24);
  --collection-bg: rgba(255, 255, 255, 0.78);
  --collection-stat-bg: rgba(255, 255, 255, 0.58);
  position: relative;
  overflow: hidden;
  min-height: 178px;
  border-color: var(--collection-border);
  background: linear-gradient(145deg, var(--collection-bg), rgba(255, 255, 255, 0.78) 68%), var(--design-surface);
  box-shadow: 0 1px 2px rgba(31, 31, 31, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.68);
  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.collection-card::before {
  content: "";
  position: absolute;
  inset: 0 0 auto;
  height: 4px;
  background: var(--collection-accent);
  opacity: 0.72;
}

.collection-card:nth-child(4n+1) {
  --collection-accent: var(--home-cta);
  --collection-border: rgba(30, 30, 30, 0.26);
  --collection-bg: rgba(255, 255, 255, 0.82);
}

.collection-card:nth-child(4n+2) {
  --collection-accent: var(--design-green);
  --collection-border: rgba(94, 102, 118, 0.28);
  --collection-bg: rgba(94, 102, 118, 0.12);
}

.collection-card:nth-child(4n+3) {
  --collection-accent: var(--design-rose);
  --collection-border: rgba(102, 102, 102, 0.24);
  --collection-bg: rgba(30, 30, 30, 0.34);
}

.collection-card:nth-child(4n) {
  --collection-accent: #38506B;
  --collection-border: rgba(56, 80, 107, 0.22);
  --collection-bg: rgba(30, 30, 30, 0.08);
}

.collection-card:hover,
.collection-card:focus-visible {
  transform: translateY(-3px);
  border-color: var(--collection-accent);
  background: linear-gradient(145deg, var(--collection-bg), rgba(255, 255, 255, 0.72) 64%), var(--design-surface);
  box-shadow: var(--home-hover-shadow);
}

.collection-card strong {
  color: var(--home-cta-hover);
  font-size: 18px;
  font-weight: 920;
}

.collection-title {
  gap: 8px;
  padding-top: 3px;
}

.collection-title em {
  color: #666666;
  font-size: 13.5px;
  font-weight: 760;
}

.collection-meta {
  gap: 10px;
}

.collection-stat-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
}

.collection-stat {
  min-width: 0;
  display: grid;
  gap: 3px;
  border: 1px solid rgba(31, 31, 31, 0.16);
  border-radius: 7px;
  padding: 7px 6px;
  background: var(--collection-stat-bg);
  box-shadow: var(--home-chip-shadow);
}

.collection-stat b {
  overflow-wrap: anywhere;
  color: var(--home-cta-hover);
  font-size: 13px;
  font-weight: 920;
  line-height: 1.1;
}

.collection-stat span {
  color: #666666;
  font-size: 11px;
  font-weight: 860;
  line-height: 1.15;
}

.collection-cta {
  justify-self: start;
  min-height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid var(--collection-accent);
  border-radius: 999px;
  padding: 0 11px;
  background: var(--home-cta);
  color: #FFFFFF;
  font-size: 12px;
  font-weight: 900;
  line-height: 1;
}

.collection-card:hover .collection-cta,
.collection-card:focus-visible .collection-cta {
  background: var(--collection-accent);
}

.bundle-card {
  --bundle-accent: var(--home-cta);
  --bundle-border: rgba(30, 30, 30, 0.22);
  --bundle-bg: rgba(255, 255, 255, 0.42);
  --bundle-chip-bg: rgba(30, 30, 30, 0.08);
  --bundle-chip-border: rgba(31, 31, 31, 0.16);
  position: relative;
  border-top-width: 1px;
  border-color: var(--bundle-border);
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.84), var(--bundle-bg)), var(--design-surface);
  cursor: pointer;
  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.bundle-card:nth-child(3n+2) {
  --bundle-accent: var(--design-green);
  --bundle-border: rgba(94, 102, 118, 0.25);
  --bundle-bg: rgba(94, 102, 118, 0.1);
  --bundle-chip-bg: rgba(94, 102, 118, 0.12);
  --bundle-chip-border: rgba(94, 102, 118, 0.18);
}

.bundle-card:nth-child(3n) {
  --bundle-accent: var(--design-rose);
  --bundle-border: rgba(102, 102, 102, 0.22);
  --bundle-bg: rgba(30, 30, 30, 0.28);
  --bundle-chip-bg: rgba(30, 30, 30, 0.34);
  --bundle-chip-border: rgba(102, 102, 102, 0.14);
}

.bundle-card:hover,
.bundle-card:focus-visible {
  transform: translateY(-3px);
  border-color: var(--bundle-accent);
  box-shadow: var(--home-hover-shadow);
}

.bundle-kicker {
  color: var(--bundle-accent);
  font-weight: 920;
}

.bundle-card strong {
  color: var(--home-cta-hover);
  font-size: 17px;
  font-weight: 920;
}

.bundle-card em {
  border: 1px solid var(--bundle-chip-border);
  border-radius: 999px;
  padding: 4px 8px;
  background: rgba(255, 255, 255, 0.52);
  color: var(--bundle-accent);
  font-weight: 900;
}

.bundle-tags {
  margin-top: 3px;
}

.bundle-tags i {
  border-color: var(--bundle-chip-border);
  background: var(--bundle-chip-bg);
  color: var(--home-cta);
  cursor: pointer;
  box-shadow: var(--home-chip-shadow);
}

.bundle-tags i:nth-child(3n+2) {
  border-color: rgba(94, 102, 118, 0.18);
  background: rgba(94, 102, 118, 0.12);
  color: #666666;
}

.bundle-tags i:nth-child(3n) {
  border-color: rgba(102, 102, 102, 0.14);
  background: rgba(30, 30, 30, 0.34);
  color: #666666;
}

.bundle-card:hover .bundle-tags i,
.bundle-card:focus-visible .bundle-tags i {
  border-color: var(--bundle-accent);
}

@media (max-width: 820px) {
  .topic-band {
    padding: 18px;
  }
  .section-description {
    font-size: 13.5px;
  }
  .collection-card {
    min-height: 168px;
  }
}
/* Review 101: featured and recent material card refinement. */
:host {
  --home-resource-bg: rgba(255, 255, 255, 0.88);
  --home-resource-warm: rgba(255, 255, 255, 0.62);
  --home-resource-border: rgba(30, 30, 30, 0.24);
  --home-resource-shadow: 0 10px 24px rgba(31, 31, 31, 0.1);
  --home-resource-shadow-hover: 0 16px 34px rgba(31, 31, 31, 0.15);
  --home-cover-paper: #F6F6F6;
  --home-cover-line: rgba(30, 30, 30, 0.22);
}

.featured-layout {
  align-items: stretch;
  gap: 20px;
}

.recommended-grid {
  gap: 16px;
}

.resource-card:not(.topic-resource-card) {
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  padding: 14px;
  border-color: var(--home-resource-border);
  background: linear-gradient(145deg, var(--home-resource-warm), rgba(255, 255, 255, 0.9) 54%, var(--home-resource-bg)), var(--design-surface);
  box-shadow: 0 1px 2px rgba(31, 31, 31, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.62);
  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.resource-card:not(.topic-resource-card):hover,
.resource-card:not(.topic-resource-card):focus-within {
  transform: translateY(-3px);
  border-color: var(--home-cta);
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.72), rgba(255, 255, 255, 0.86) 58%, #FFFFFF), var(--design-surface);
  box-shadow: var(--home-resource-shadow-hover);
}

.resource-main-link {
  min-width: 0;
  display: grid;
  grid-template-columns: 106px minmax(0, 1fr);
  gap: 16px;
  color: inherit;
  text-decoration: none;
}

.cover-frame {
  position: relative;
  width: 106px;
  border-color: rgba(30, 30, 30, 0.22);
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.96), rgba(30, 30, 30, 0.26));
  box-shadow: 0 10px 18px rgba(31, 31, 31, 0.12);
}

.cover-frame img {
  object-fit: cover;
}

.cover-frame.is-placeholder {
  overflow: hidden;
  background: linear-gradient(90deg, rgba(31, 31, 31, 0.16) 0 8px, transparent 8px), linear-gradient(145deg, var(--home-cover-paper), #FFFFFF 58%, rgba(30, 30, 30, 0.42));
}

.cover-frame.is-placeholder::before {
  content: "";
  position: absolute;
  inset: 12px 11px;
  border: 1px solid var(--home-cover-line);
  border-radius: 6px;
  pointer-events: none;
}

.cover-placeholder {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr auto;
  gap: 8px;
  padding: 16px 13px 14px 18px;
  color: var(--home-cta-hover);
}

.cover-placeholder .placeholder-type {
  justify-self: start;
  max-width: 100%;
  border: 1px solid rgba(30, 30, 30, 0.2);
  border-radius: 999px;
  padding: 3px 7px;
  background: rgba(255, 255, 255, 0.68);
  color: var(--home-cta);
  font-size: 10px;
  font-weight: 900;
  line-height: 1.1;
}

.cover-placeholder strong {
  align-self: center;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  color: var(--home-cta-hover);
  font-size: 12.5px;
  font-weight: 920;
  line-height: 1.34;
  overflow-wrap: anywhere;
}

.cover-placeholder em {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #666666;
  font-size: 10.5px;
  font-style: normal;
  font-weight: 820;
  line-height: 1.3;
}

.resource-body {
  min-width: 0;
  gap: 8px;
  align-content: start;
}

.resource-kicker,
.recent-row-top {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
}

.resource-kicker small,
.recent-row-top i {
  max-width: 100%;
  border: 1px solid rgba(30, 30, 30, 0.2);
  border-radius: 999px;
  padding: 4px 8px;
  background: rgba(30, 30, 30, 0.08);
  color: var(--home-cta);
  font-size: 11px;
  font-style: normal;
  font-weight: 900;
  line-height: 1.1;
}

.resource-kicker i,
.recent-row-top em {
  color: #666666;
  font-size: 12px;
  font-style: normal;
  font-weight: 850;
}

.resource-body > strong {
  color: var(--home-cta-hover);
  font-size: 17px;
  font-weight: 920;
  line-height: 1.36;
}

.resource-body > em {
  color: #666666;
  font-size: 13px;
  font-weight: 780;
}

.resource-card .badge-row {
  margin-top: 1px;
}

.resource-card .badge-row i,
.recent-feature-row i {
  border-color: rgba(31, 31, 31, 0.16);
  background: rgba(255, 255, 255, 0.62);
  color: #666666;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.58);
}

.resource-actions {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 7px;
}

.resource-action {
  min-width: 0;
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid rgba(31, 31, 31, 0.34);
  border-radius: 8px;
  padding: 0 9px;
  background: var(--home-cta);
  color: #FFFFFF;
  font-size: 12px;
  font-weight: 900;
  line-height: 1.15;
  text-decoration: none;
  white-space: nowrap;
  transition: border-color 160ms ease, background 160ms ease, color 160ms ease, transform 160ms ease;
}

.resource-action i {
  flex: 0 0 auto;
  font-size: 12px;
}

.resource-action:hover,
.resource-action:focus-visible {
  border-color: var(--home-cta-hover);
  background: var(--home-cta-hover);
  color: #FFFFFF;
  transform: translateY(-1px);
}

.resource-action.is-muted {
  border-color: rgba(30, 30, 30, 0.2);
  background: rgba(255, 255, 255, 0.72);
  color: var(--home-cta);
}

.recent-rail {
  width: min(380px, 35%);
  border-left-color: rgba(30, 30, 30, 0.2);
  padding-left: 20px;
}

.recent-list {
  gap: 10px;
}

.recent-row {
  gap: 7px;
  padding: 13px 14px;
  border-color: rgba(30, 30, 30, 0.2);
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.86), rgba(255, 255, 255, 0.44)), var(--design-surface);
  box-shadow: 0 1px 2px rgba(31, 31, 31, 0.08);
  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.recent-row:hover,
.recent-row:focus-visible {
  transform: translateY(-2px);
  border-color: var(--home-cta);
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.66), rgba(255, 255, 255, 0.88)), var(--design-surface);
  box-shadow: var(--home-resource-shadow);
}

.recent-row strong {
  color: var(--home-cta-hover);
  font-size: 14.5px;
  font-weight: 920;
  line-height: 1.35;
}

.recent-row > span:not(.recent-row-top):not(.recent-feature-row) {
  color: #666666;
  font-size: 12.5px;
  font-weight: 780;
}

.recent-feature-row {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 1px;
}

.recent-feature-row i {
  border: 1px solid rgba(31, 31, 31, 0.16);
  border-radius: 999px;
  padding: 3px 6px;
  font-size: 10.5px;
  font-style: normal;
  font-weight: 880;
}

@media (max-width: 1180px) {
  .recent-rail {
    width: 100%;
    border-left: 0;
    border-top: 1px solid rgba(30, 30, 30, 0.2);
    padding: 18px 0 0;
  }
  .recent-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 820px) {
  .resource-main-link {
    grid-template-columns: 88px minmax(0, 1fr);
    gap: 13px;
  }
  .cover-frame {
    width: 88px;
  }
  .resource-actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .resource-action {
    min-height: 38px;
  }
  .recent-list {
    grid-template-columns: 1fr;
  }
}
/* Review 105: search-first landing with restrained autumn mute tone. */
:host {
  --design-bg: #FFFFFF;
  --design-surface: #FFFFFF;
  --design-surface-muted: #FAFAFA;
  --design-surface-tinted: #FAFAFA;
  --design-text: #1F1F1F;
  --design-text-secondary: #666666;
  --design-text-muted: #8A8A8A;
  --design-border: #E5E5E5;
  --design-border-strong: #D8D8D8;
  --design-accent: #1F1F1F;
  --design-accent-strong: #2B2B2B;
  --design-accent-wash: rgba(94, 102, 118, 0.08);
  --design-green: #5E6676;
  --design-green-wash: rgba(94, 102, 118, 0.1);
  --design-amber: #F5F5F5;
  --design-amber-wash: rgba(30, 30, 30, 0.28);
  --design-rose: #666666;
  --design-rose-wash: rgba(102, 102, 102, 0.12);
  --home-cta: #1F1F1F;
  --home-cta-hover: #2B2B2B;
  --home-olive: #5E6676;
  --home-search-shadow: 0 18px 44px rgba(30, 30, 30, 0.08);
  --home-hover-shadow: 0 10px 30px rgba(30, 30, 30, 0.07);
  --home-chip-shadow: none;
  background: var(--design-bg);
}

.home-page {
  width: min(1320px, 100%);
  padding: 20px 28px 64px;
}

.home-header {
  margin-bottom: 18px;
}

.brand-symbol {
  width: 38px;
  height: 38px;
  border-color: var(--design-border);
  background: #FFFFFF;
  color: var(--design-accent);
  box-shadow: none;
}

.primary-nav a,
.header-link {
  color: var(--design-text-secondary);
}

.header-link {
  border-color: var(--design-border);
  background: rgba(255, 255, 255, 0.78);
  color: var(--design-accent);
  box-shadow: none;
}

.home-auth .header-link:last-child {
  border-color: var(--home-cta);
  background: var(--home-cta);
  color: #FFFFFF;
}

.home-auth .header-link:hover,
.home-auth .header-link:focus-visible,
.home-auth .header-link:last-child:hover,
.home-auth .header-link:last-child:focus-visible {
  border-color: var(--home-cta-hover);
  background: var(--home-cta-hover);
  color: #FFFFFF;
  box-shadow: 0 0 0 3px rgba(94, 102, 118, 0.16);
}

.search-band {
  min-height: clamp(500px, 100vh - 126px, 660px);
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-content: center;
  justify-items: center;
  gap: 24px;
  border: 1px solid var(--design-border);
  border-radius: 12px;
  padding: clamp(34px, 6vw, 76px) clamp(20px, 5vw, 72px);
  background: #FFFFFF;
  box-shadow: var(--home-search-shadow);
}

.search-copy {
  max-width: 760px;
  display: grid;
  justify-items: center;
  gap: 12px;
  padding: 0;
  text-align: center;
}

.search-copy .eyebrow {
  margin: 0;
  border: 1px solid rgba(94, 102, 118, 0.18);
  border-radius: 999px;
  padding: 6px 11px;
  background: rgba(94, 102, 118, 0.08);
  color: var(--design-green);
  font-size: 12px;
}

h1 {
  max-width: 760px;
  font-size: clamp(34px, 4.4vw, 54px);
  line-height: 1.12;
  letter-spacing: 0;
}

.search-copy p:last-child {
  max-width: 620px;
  margin: 0;
  color: var(--design-text-secondary);
  font-size: 16px;
  line-height: 1.62;
}

.home-search {
  width: min(860px, 100%);
  gap: 13px;
  justify-items: stretch;
}

.search-scope-tabs {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px;
}

.search-scope-tabs a {
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 999px;
  padding: 0 13px;
  background: transparent;
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 850;
  text-decoration: none;
}

.search-scope-tabs a.is-active,
.search-scope-tabs a:hover,
.search-scope-tabs a:focus-visible {
  border-color: rgba(94, 102, 118, 0.18);
  background: rgba(94, 102, 118, 0.09);
  color: var(--design-accent);
  outline: none;
}

.search-box {
  min-height: 76px;
  border: 1px solid var(--design-border-strong);
  border-radius: 12px;
  padding: 10px 11px 10px 22px;
  background: #FFFFFF;
  box-shadow: 0 10px 30px rgba(30, 30, 30, 0.06);
}

.search-box > i {
  color: var(--design-green);
  font-size: 21px;
}

.search-box input {
  color: var(--design-text);
  font-size: 20px;
  font-weight: 780;
}

.search-box input::placeholder {
  color: rgba(102, 102, 102, 0.72);
}

.search-box:focus-within {
  border-color: var(--design-green);
  box-shadow: 0 0 0 3px rgba(94, 102, 118, 0.16), 0 12px 34px rgba(30, 30, 30, 0.08);
}

.search-box button {
  min-height: 54px;
  border: 1px solid var(--home-cta);
  border-radius: 9px;
  padding: 0 24px;
  background: var(--home-cta);
  color: #FFFFFF;
  font-size: 15px;
  box-shadow: none;
}

.search-box button:hover,
.search-box button:focus-visible {
  border-color: var(--home-cta-hover);
  background: var(--home-cta-hover);
  box-shadow: none;
}

.topic-strip,
.search-actions {
  justify-content: center;
}

.topic-strip > span {
  color: var(--design-text-secondary);
}

.topic-strip a {
  border-color: rgba(30, 30, 30, 0.9);
  background: #FAFAFA;
  color: var(--design-accent);
  box-shadow: none;
}

.topic-strip a:nth-of-type(3n + 2) {
  border-color: rgba(94, 102, 118, 0.16);
  background: rgba(94, 102, 118, 0.08);
}

.topic-strip a:nth-of-type(3n) {
  border-color: rgba(102, 102, 102, 0.16);
  background: rgba(102, 102, 102, 0.08);
}

.secondary-action {
  min-height: 38px;
  border-color: var(--design-border);
  border-radius: 8px;
  background: #FFFFFF;
  color: var(--design-accent);
  box-shadow: none;
}

.secondary-action:hover,
.secondary-action:focus-visible,
.topic-strip a:hover,
.topic-strip a:focus-visible {
  border-color: var(--design-green);
  background: rgba(94, 102, 118, 0.1);
  color: var(--design-accent-strong);
  box-shadow: none;
}

.content-band {
  margin-top: 34px;
  border-top: 1px solid rgba(221, 210, 196, 0.82);
  padding-top: 28px;
  background: transparent;
}

.topic-band {
  border: 0;
  border-top: 1px solid rgba(221, 210, 196, 0.82);
  border-radius: 0;
  padding: 32px 0 0;
  background: transparent;
  box-shadow: none;
}

.section-description,
.collection-title em,
.resource-body em,
.recent-row > span:not(.recent-row-top):not(.recent-feature-row) {
  color: var(--design-text-secondary);
}

.section-heading a,
.topic-band .section-heading a {
  border: 1px solid var(--design-border);
  border-radius: 8px;
  padding: 0 12px;
  background: #FFFFFF;
  color: var(--design-accent);
  box-shadow: none;
}

.section-heading a:hover,
.section-heading a:focus-visible,
.topic-band .section-heading a:hover,
.topic-band .section-heading a:focus-visible {
  border-color: var(--design-green);
  background: rgba(94, 102, 118, 0.1);
  color: var(--design-accent-strong);
  box-shadow: none;
}

.entry-band {
  display: grid;
  gap: 16px;
}

.entry-grid,
.metric-strip,
.collection-grid,
.recommended-grid,
.recent-list,
.bundle-grid {
  gap: 14px;
}

.entry-card,
.metric-card,
.collection-card,
.resource-card:not(.topic-resource-card),
.recent-row,
.bundle-card,
.flow-step,
.home-profile {
  border: 1px solid var(--design-border);
  border-top-width: 1px;
  background: #FFFFFF;
  box-shadow: 0 10px 30px rgba(30, 30, 30, 0.055);
}

.entry-card,
.collection-card,
.bundle-card,
.flow-step {
  position: relative;
}

.entry-card::before,
.collection-card::before,
.bundle-card::before,
.flow-step::before {
  content: "";
  position: absolute;
  inset: 0 auto auto 0;
  width: 100%;
  height: 2px;
  background: rgba(94, 102, 118, 0.32);
  opacity: 0;
}

.entry-card.tone-cream,
.metric-card.tone-cream,
.entry-card.tone-charcoal,
.metric-card.tone-charcoal {
  --tone-accent: var(--design-accent);
  --tone-border: var(--design-border);
  --tone-card-bg: #FFFFFF;
  --tone-icon-bg: rgba(94, 102, 118, 0.08);
  --tone-pill-bg: rgba(94, 102, 118, 0.08);
}

.entry-card.tone-olive,
.metric-card.tone-olive {
  --tone-accent: var(--design-green);
  --tone-border: var(--design-border);
  --tone-card-bg: #FFFFFF;
  --tone-icon-bg: rgba(94, 102, 118, 0.1);
  --tone-pill-bg: rgba(94, 102, 118, 0.08);
}

.entry-card.tone-beige,
.metric-card.tone-beige {
  --tone-accent: #666A72;
  --tone-border: var(--design-border);
  --tone-card-bg: #FFFFFF;
  --tone-icon-bg: rgba(30, 30, 30, 0.32);
  --tone-pill-bg: rgba(30, 30, 30, 0.24);
}

.entry-card.tone-clay,
.metric-card.tone-clay {
  --tone-accent: #9C6D45;
  --tone-border: var(--design-border);
  --tone-card-bg: #FFFFFF;
  --tone-icon-bg: rgba(102, 102, 102, 0.13);
  --tone-pill-bg: rgba(102, 102, 102, 0.1);
}

.entry-card.tone-bluegrey,
.metric-card.tone-bluegrey {
  --tone-accent: #38506B;
  --tone-border: var(--design-border);
  --tone-card-bg: #FFFFFF;
  --tone-icon-bg: rgba(56, 80, 107, 0.08);
  --tone-pill-bg: rgba(56, 80, 107, 0.07);
}

.entry-card {
  min-height: 146px;
  padding: 15px;
  transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.entry-card:hover,
.entry-card:focus-visible,
.collection-card:hover,
.collection-card:focus-visible,
.resource-card:hover,
.resource-card:focus-visible,
.recent-row:hover,
.recent-row:focus-visible,
.bundle-card:hover,
.bundle-card:focus-visible,
.flow-step:hover,
.flow-step:focus-visible {
  transform: none;
  border-color: #D8D8D8;
  background: #FFFFFF;
  box-shadow: 0 12px 32px rgba(30, 30, 30, 0.08);
  outline: none;
}

.entry-card:hover::before,
.entry-card:focus-visible::before,
.collection-card:hover::before,
.collection-card:focus-visible::before,
.bundle-card:hover::before,
.bundle-card:focus-visible::before,
.flow-step:hover::before,
.flow-step:focus-visible::before {
  opacity: 1;
}

.entry-icon,
.flow-step span,
.topic-cover {
  width: 36px;
  height: 36px;
  border: 1px solid rgba(94, 102, 118, 0.14);
  border-radius: 8px;
  background: rgba(94, 102, 118, 0.08);
  color: var(--design-green);
}

.entry-card:hover .entry-icon,
.entry-card:focus-visible .entry-icon {
  transform: none;
  background: rgba(94, 102, 118, 0.11);
}

.entry-card em,
.metric-card em,
.bundle-card em,
.collection-stat,
.resource-kicker small,
.recent-row-top i,
.badge-row i,
.bundle-tags i,
.resource-card .badge-row i,
.recent-feature-row i {
  border-color: rgba(221, 210, 196, 0.9);
  background: #FAFAFA;
  color: var(--design-text-secondary);
  box-shadow: none;
}

.metric-card {
  min-height: 88px;
  padding: 13px 14px;
}

.collection-card {
  --collection-accent: var(--design-green);
  --collection-border: var(--design-border);
  --collection-bg: #FFFFFF;
  --collection-stat-bg: #FAFAFA;
  min-height: 164px;
  border-color: var(--design-border);
  background: #FFFFFF;
}

.collection-card:nth-child(4n+1),
.collection-card:nth-child(4n+2),
.collection-card:nth-child(4n+3),
.collection-card:nth-child(4n) {
  --collection-border: var(--design-border);
  --collection-bg: #FFFFFF;
}

.collection-card::before {
  height: 2px;
  background: var(--collection-accent, var(--design-green));
  opacity: 0.36;
}

.collection-card strong,
.bundle-card strong,
.resource-body > strong,
.recent-row strong {
  color: var(--design-text);
}

.collection-title em,
.collection-stat span {
  color: var(--design-text-secondary);
}

.collection-cta,
.resource-action {
  border-color: var(--home-cta);
  border-radius: 8px;
  background: var(--home-cta);
  color: #FFFFFF;
  box-shadow: none;
}

.collection-card:hover .collection-cta,
.collection-card:focus-visible .collection-cta,
.resource-action:hover,
.resource-action:focus-visible {
  border-color: var(--home-cta-hover);
  background: var(--home-cta-hover);
  transform: none;
}

.bundle-card,
.bundle-card:nth-child(3n+2),
.bundle-card:nth-child(3n) {
  --bundle-accent: var(--design-green);
  --bundle-border: var(--design-border);
  --bundle-bg: #FFFFFF;
  --bundle-chip-bg: #FAFAFA;
  --bundle-chip-border: rgba(221, 210, 196, 0.9);
  background: #FFFFFF;
}

.bundle-kicker,
.entry-label,
.metric-card small {
  color: var(--tone-accent, var(--design-green));
}

.resource-card:not(.topic-resource-card),
.resource-card:not(.topic-resource-card):hover,
.resource-card:not(.topic-resource-card):focus-within,
.recent-row,
.recent-row:hover,
.recent-row:focus-visible {
  border-color: var(--design-border);
  background: #FFFFFF;
}

.cover-frame,
.cover-frame.is-placeholder,
.modal-cover,
.related-cover {
  border-color: rgba(221, 210, 196, 0.95);
  background: linear-gradient(145deg, #FAFAFA, #FFFFFF);
  box-shadow: 0 10px 24px rgba(30, 30, 30, 0.07);
}

.cover-frame.is-placeholder {
  background: linear-gradient(90deg, rgba(94, 102, 118, 0.12) 0 7px, transparent 7px), linear-gradient(145deg, #FAFAFA, #FFFFFF 60%, rgba(30, 30, 30, 0.24));
}

.cover-placeholder .placeholder-type {
  border-color: rgba(221, 210, 196, 0.9);
  background: rgba(255, 255, 255, 0.75);
  color: var(--design-green);
}

.recent-rail {
  border-left-color: var(--design-border);
}

.graph-band {
  border: 1px solid var(--design-border);
  border-radius: 10px;
  background: #FFFFFF;
  box-shadow: 0 10px 30px rgba(30, 30, 30, 0.055);
}

.graph-action {
  border: 1px solid var(--home-cta);
  border-radius: 8px;
  background: var(--home-cta);
  color: #FFFFFF;
  box-shadow: none;
}

.graph-action:hover,
.graph-action:focus-visible {
  border-color: var(--home-cta-hover);
  background: var(--home-cta-hover);
  box-shadow: none;
}

@media (max-width: 1180px) {
  .search-band {
    min-height: auto;
    padding: 42px 26px;
  }
}
@media (max-width: 820px) {
  .home-page {
    padding: 15px 14px 44px;
  }
  .home-header {
    gap: 12px;
  }
  .search-band {
    align-content: start;
    gap: 18px;
    padding: 28px 16px;
  }
  h1 {
    font-size: 31px;
  }
  .search-copy p:last-child {
    font-size: 14.5px;
  }
  .search-box {
    min-height: 0;
    padding: 11px;
  }
  .search-box input {
    flex-basis: calc(100% - 34px);
    min-height: 40px;
    font-size: 17px;
  }
  .search-box button {
    width: 100%;
  }
  .search-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
  }
  .secondary-action {
    width: 100%;
    padding: 0 9px;
  }
  .entry-card,
  .collection-card,
  .bundle-card,
  .flow-step {
    min-height: auto;
  }
}
/* Review 106: open white search-first home and autumn-mute topic cards. */
:host {
  --design-bg: #FFFFFF;
  --design-surface: #FFFFFF;
  --design-surface-muted: #FAFAFA;
  --design-surface-tinted: #FFFFFF;
  --design-text: #1F1F1F;
  --design-text-secondary: #666666;
  --design-text-muted: #8A8A8A;
  --design-border: #E5E5E5;
  --design-border-strong: #D8D8D8;
  --design-accent: #1F1F1F;
  --design-accent-strong: #2B2B2B;
  --design-green: #5E6676;
  --design-clay: #687086;
  --design-brown-orange: #666666;
  --home-cta: #1F1F1F;
  --home-cta-hover: #2B2B2B;
  --home-search-shadow: none;
  --home-hover-shadow: 0 10px 24px rgba(30, 30, 30, 0.08);
  min-height: 100vh;
  background: #FFFFFF;
}

.home-page {
  width: 100%;
  max-width: none;
  min-height: 100vh;
  padding: 22px 28px 64px;
  background: #FFFFFF;
  box-sizing: border-box;
}

.home-header {
  width: min(1320px, 100%);
  margin: 0 auto;
}

.brand-symbol {
  border-color: var(--design-border-strong);
  background: #FFFFFF;
}

.header-link,
.home-profile {
  border-color: var(--design-border);
  background: #FFFFFF;
}

.search-band {
  width: min(1320px, 100%);
  min-height: auto;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-content: start;
  justify-items: center;
  gap: 18px;
  margin: 0 auto;
  border: 0;
  border-radius: 0;
  padding: 48px 0 54px;
  background: #FFFFFF;
  box-shadow: none;
}

.search-copy {
  max-width: 720px;
  gap: 9px;
  text-align: center;
}

.search-copy .eyebrow {
  border: 0;
  border-radius: 0;
  padding: 0;
  background: transparent;
  color: var(--design-text-secondary);
  font-size: 12px;
}

h1 {
  max-width: 720px;
  font-size: clamp(31px, 3.7vw, 44px);
  line-height: 1.15;
}

.search-copy p:last-child {
  max-width: 600px;
  font-size: 15px;
  line-height: 1.56;
}

.home-search {
  width: min(820px, 100%);
  gap: 10px;
}

.search-scope-tabs {
  justify-content: center;
  gap: 5px;
}

.search-scope-tabs a {
  min-height: 30px;
  border-color: transparent;
  border-radius: 8px;
  padding: 0 11px;
  background: transparent;
  color: var(--design-text-secondary);
  font-size: 12px;
}

.search-scope-tabs a.is-active,
.search-scope-tabs a:hover,
.search-scope-tabs a:focus-visible {
  border-color: var(--design-border);
  background: #FAFAFA;
  color: var(--design-accent);
}

.search-box {
  min-height: 64px;
  border: 1px solid #D8D8D8;
  border-radius: 8px;
  padding: 8px 9px 8px 18px;
  background: #FFFFFF;
  box-shadow: none;
}

.search-box > i {
  color: var(--design-green);
  font-size: 19px;
}

.search-box input {
  color: var(--design-text);
  font-size: 18px;
  font-weight: 760;
}

.search-box input::placeholder {
  color: rgba(102, 102, 102, 0.7);
}

.search-box:focus-within {
  border-color: var(--design-green);
  box-shadow: 0 0 0 3px rgba(94, 102, 118, 0.13);
}

.search-box button {
  min-height: 46px;
  border: 1px solid var(--home-cta);
  border-radius: 8px;
  padding: 0 20px;
  background: var(--home-cta);
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 820;
  box-shadow: none;
}

.search-box button:hover,
.search-box button:focus-visible {
  border-color: var(--home-cta-hover);
  background: var(--home-cta-hover);
}

.topic-strip,
.search-actions {
  justify-content: center;
  gap: 7px;
}

.topic-strip > span {
  color: var(--design-text-secondary);
  font-size: 12px;
}

.topic-strip a {
  border-color: var(--design-border);
  background: #FAFAFA;
  color: var(--design-text-secondary);
  padding: 6px 9px;
  font-size: 12px;
  box-shadow: none;
}

.topic-strip a:nth-of-type(3n + 2) {
  border-color: rgba(94, 102, 118, 0.16);
  background: rgba(94, 102, 118, 0.06);
}

.topic-strip a:nth-of-type(3n) {
  border-color: rgba(30, 30, 30, 0.7);
  background: rgba(31, 31, 31, 0.16);
}

.secondary-action {
  min-height: 36px;
  border-color: var(--design-border);
  border-radius: 8px;
  background: #FFFFFF;
  color: var(--design-accent);
  padding: 0 11px;
  font-size: 12px;
  box-shadow: none;
}

.secondary-action:hover,
.secondary-action:focus-visible,
.topic-strip a:hover,
.topic-strip a:focus-visible {
  border-color: var(--design-green);
  background: rgba(94, 102, 118, 0.08);
  color: var(--design-accent-strong);
}

.content-band {
  width: min(1320px, 100%);
  margin: 36px auto 0;
  border-top: 1px solid var(--design-border);
  padding-top: 30px;
  background: transparent;
}

.topic-band {
  margin: 10px auto 0;
  border: 0;
  border-top: 1px solid var(--design-border);
  border-radius: 0;
  padding: 40px 0 0;
  background: transparent;
  box-shadow: none;
}

.topic-band .section-heading {
  margin-bottom: 20px;
}

.section-heading a,
.topic-band .section-heading a {
  min-height: 36px;
  border-color: var(--design-border);
  background: #FFFFFF;
  color: var(--design-accent);
  box-shadow: none;
}

.section-heading a:hover,
.section-heading a:focus-visible,
.topic-band .section-heading a:hover,
.topic-band .section-heading a:focus-visible {
  border-color: var(--design-green);
  background: rgba(94, 102, 118, 0.08);
  color: var(--design-accent-strong);
}

.collection-grid {
  gap: 18px;
}

.collection-card {
  --collection-accent: var(--design-green);
  --collection-border: rgba(94, 102, 118, 0.22);
  --collection-bg: rgba(94, 102, 118, 0.12);
  --collection-stat-bg: rgba(255, 255, 255, 0.58);
  min-height: 190px;
  gap: 16px;
  border-color: var(--collection-border);
  padding: 20px;
  background: linear-gradient(145deg, var(--collection-bg), rgba(255, 255, 255, 0.72) 74%), #FFFFFF;
  box-shadow: none;
}

.collection-card:nth-child(8n+1) {
  --collection-accent: #5E6676;
  --collection-border: rgba(94, 102, 118, 0.28);
  --collection-bg: rgba(94, 102, 118, 0.14);
}

.collection-card:nth-child(8n+2) {
  --collection-accent: #687086;
  --collection-border: rgba(104, 112, 134, 0.32);
  --collection-bg: rgba(104, 112, 134, 0.18);
}

.collection-card:nth-child(8n+3) {
  --collection-accent: #1F1F1F;
  --collection-border: rgba(30, 30, 30, 0.24);
  --collection-bg: rgba(30, 30, 30, 0.1);
}

.collection-card:nth-child(8n+4) {
  --collection-accent: #666666;
  --collection-border: rgba(188, 108, 37, 0.26);
  --collection-bg: rgba(188, 108, 37, 0.11);
}

.collection-card:nth-child(8n+5) {
  --collection-accent: #F5F5F5;
  --collection-border: rgba(188, 108, 37, 0.2);
  --collection-bg: rgba(30, 30, 30, 0.34);
}

.collection-card:nth-child(8n+6) {
  --collection-accent: #5E6676;
  --collection-border: rgba(94, 102, 118, 0.24);
  --collection-bg: rgba(94, 102, 118, 0.1);
}

.collection-card:nth-child(8n+7) {
  --collection-accent: #687086;
  --collection-border: rgba(104, 112, 134, 0.28);
  --collection-bg: rgba(104, 112, 134, 0.14);
}

.collection-card:nth-child(8n) {
  --collection-accent: #1F1F1F;
  --collection-border: rgba(30, 30, 30, 0.22);
  --collection-bg: rgba(30, 30, 30, 0.08);
}

.collection-card::before {
  height: 3px;
  background: var(--collection-accent);
  opacity: 0.62;
}

.collection-card:hover,
.collection-card:focus-visible {
  border-color: var(--collection-accent);
  background: linear-gradient(145deg, var(--collection-bg), rgba(255, 255, 255, 0.66) 70%), #FFFFFF;
  box-shadow: var(--home-hover-shadow);
}

.collection-card strong {
  color: var(--design-text);
  font-size: 18px;
  font-weight: 900;
}

.collection-title {
  gap: 9px;
}

.collection-title em {
  color: var(--design-text-secondary);
  font-size: 13.5px;
  font-weight: 760;
}

.collection-meta {
  gap: 12px;
}

.collection-stat {
  border-color: rgba(255, 255, 255, 0.52);
  background: var(--collection-stat-bg);
}

.collection-stat b {
  color: var(--design-text);
}

.collection-stat span {
  color: var(--design-text-secondary);
}

.collection-cta {
  min-height: 32px;
  border-color: rgba(31, 31, 31, 0.92);
  border-radius: 8px;
  padding: 0 12px;
  background: var(--home-cta);
  color: #FFFFFF;
  font-size: 12px;
  font-weight: 850;
}

.collection-card:hover .collection-cta,
.collection-card:focus-visible .collection-cta {
  border-color: var(--home-cta-hover);
  background: var(--home-cta-hover);
}

@media (max-width: 1180px) {
  .search-band {
    padding: 40px 0 48px;
  }
}
@media (max-width: 820px) {
  .home-page {
    padding: 15px 14px 44px;
  }
  .search-band {
    gap: 16px;
    padding: 26px 0 32px;
  }
  .search-copy {
    gap: 8px;
  }
  h1 {
    font-size: 30px;
  }
  .search-box {
    min-height: 0;
    padding: 10px;
  }
  .search-box input {
    flex-basis: calc(100% - 32px);
    min-height: 38px;
    font-size: 16px;
  }
  .search-box button {
    width: 100%;
    min-height: 46px;
  }
  .topic-strip,
  .search-actions {
    justify-content: flex-start;
    flex-wrap: nowrap;
    overflow-x: auto;
    width: 100%;
    padding-bottom: 2px;
  }
  .topic-strip > span,
  .topic-strip a,
  .secondary-action {
    flex: 0 0 auto;
  }
  .search-actions {
    display: flex;
    grid-template-columns: none;
  }
  .topic-band {
    padding-top: 32px;
  }
  .collection-card {
    min-height: 176px;
    padding: 18px;
  }
}
/* Review 107: real cover driven library cards and compact action pills. */
.recommended-grid {
  align-items: start;
  gap: 12px;
}

.resource-card:not(.topic-resource-card) {
  align-content: start;
  gap: 10px;
  min-height: auto;
  padding: 12px;
  border-color: var(--design-border);
  background: #FFFFFF;
  box-shadow: 0 8px 20px rgba(30, 30, 30, 0.05);
}

.resource-card:not(.topic-resource-card):hover,
.resource-card:not(.topic-resource-card):focus-within {
  border-color: var(--design-border-strong);
  background: #FFFFFF;
  box-shadow: 0 10px 24px rgba(30, 30, 30, 0.07);
}

.resource-main-link {
  grid-template-columns: 84px minmax(0, 1fr);
  gap: 13px;
  align-items: start;
}

.cover-frame,
.cover-frame.is-placeholder {
  width: 84px;
  aspect-ratio: 2/3;
  border-radius: 6px;
  border-color: #E5E5E5;
  background: #FAFAFA;
  box-shadow: 0 8px 18px rgba(30, 30, 30, 0.08);
}

.cover-frame img {
  object-fit: cover;
  object-position: center;
  background: #FAFAFA;
}

.cover-frame.is-placeholder {
  background: linear-gradient(90deg, rgba(31, 31, 31, 0.12) 0 7px, transparent 7px), linear-gradient(145deg, #FAFAFA, #FFFFFF 62%, rgba(30, 30, 30, 0.22));
}

.cover-frame.is-placeholder::before {
  inset: 10px 9px;
  border-color: rgba(31, 31, 31, 0.14);
  border-radius: 5px;
}

.cover-placeholder {
  gap: 6px;
  padding: 13px 10px 11px 16px;
}

.cover-placeholder .placeholder-type {
  padding: 3px 6px;
  font-size: 9.5px;
}

.cover-placeholder strong {
  -webkit-line-clamp: 3;
  color: var(--design-text);
  font-size: 11.5px;
  line-height: 1.32;
}

.cover-placeholder em {
  -webkit-line-clamp: 1;
  color: var(--design-text-muted);
  font-size: 10px;
}

.resource-body {
  gap: 6px;
}

.resource-kicker {
  gap: 6px;
}

.resource-kicker small,
.recent-row-top i {
  min-height: 22px;
  padding: 4px 7px;
  font-size: 10.5px;
}

.resource-kicker i,
.recent-row-top em {
  font-size: 11.5px;
}

.resource-body > strong {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  font-size: 15px;
  line-height: 1.34;
}

.resource-body > em,
.recent-row-link > span:not(.recent-row-top) {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.resource-card .badge-row {
  gap: 5px;
}

.resource-card .badge-row i {
  padding: 3px 6px;
  font-size: 10.5px;
}

.resource-actions,
.recent-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.resource-action,
.recent-action {
  flex: 0 0 auto;
  width: auto;
  min-width: 0;
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: 1px solid #D8D8D8;
  border-radius: 999px;
  padding: 0 10px;
  background: #FFFFFF;
  color: var(--design-accent);
  font-size: 12px;
  font-weight: 820;
  line-height: 1;
  text-decoration: none;
  white-space: nowrap;
  box-shadow: none;
  transition: border-color 160ms ease, background 160ms ease, color 160ms ease;
}

.resource-action i,
.recent-action i {
  flex: 0 0 auto;
  font-size: 11px;
}

.resource-action.action-original:not(.is-muted),
.recent-action.action-original:not(.is-muted) {
  border-color: var(--home-cta);
  background: var(--home-cta);
  color: #FFFFFF;
}

.resource-action.action-body,
.resource-action.action-graph,
.recent-action.action-body,
.recent-action.action-graph {
  background: #FFFFFF;
}

.resource-action.action-topic,
.recent-action.action-topic {
  min-height: 30px;
  padding: 0 9px;
  background: rgba(94, 102, 118, 0.07);
  color: var(--design-green);
  font-size: 11.5px;
}

.resource-action:hover,
.resource-action:focus-visible,
.recent-action:hover,
.recent-action:focus-visible {
  border-color: var(--design-green);
  background: rgba(94, 102, 118, 0.09);
  color: var(--design-accent-strong);
  transform: none;
  outline: none;
}

.resource-action.action-original:not(.is-muted):hover,
.resource-action.action-original:not(.is-muted):focus-visible,
.recent-action.action-original:not(.is-muted):hover,
.recent-action.action-original:not(.is-muted):focus-visible {
  border-color: var(--home-cta-hover);
  background: var(--home-cta-hover);
  color: #FFFFFF;
}

.resource-action.is-muted,
.recent-action.is-muted {
  border-color: #E5E5E5;
  background: #FAFAFA;
  color: var(--design-text-muted);
}

.recent-rail {
  width: min(360px, 33%);
  padding-left: 18px;
}

.recent-list {
  gap: 8px;
}

.recent-row {
  gap: 8px;
  min-height: auto;
  padding: 10px 11px;
  border-color: var(--design-border);
  background: #FFFFFF;
}

.recent-row-link {
  min-width: 0;
  display: grid;
  gap: 4px;
  color: inherit;
  text-decoration: none;
}

.recent-row-link:focus-visible {
  outline: 2px solid rgba(94, 102, 118, 0.24);
  outline-offset: 2px;
}

.recent-row strong {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 13.5px;
  line-height: 1.32;
}

.recent-row > span:not(.recent-row-top):not(.recent-feature-row),
.recent-row-link > span:not(.recent-row-top) {
  color: var(--design-text-secondary);
  font-size: 12px;
  font-weight: 760;
}

.recent-actions {
  gap: 5px;
}

.recent-action {
  min-height: 30px;
  padding: 0 8px;
  font-size: 11px;
}

@media (max-width: 1180px) {
  .recent-rail {
    width: 100%;
  }
}
@media (max-width: 820px) {
  .resource-main-link {
    grid-template-columns: 76px minmax(0, 1fr);
    gap: 11px;
  }
  .cover-frame,
  .cover-frame.is-placeholder {
    width: 76px;
  }
  .resource-actions,
  .recent-actions {
    gap: 5px;
  }
  .resource-action,
  .recent-action {
    min-height: 32px;
    padding: 0 8px;
    font-size: 11px;
  }
}
/* Review 108: centered first-screen search and no top-line cards. */
.search-band {
  min-height: calc(100vh - 88px);
  min-height: calc(100svh - 88px);
  align-content: center;
  gap: 22px;
  padding: 34px 0 48px;
}

.search-copy {
  gap: 10px;
}

h1 {
  font-size: clamp(34px, 3.9vw, 48px);
  line-height: 1.14;
}

.search-copy p:last-child {
  font-size: 15.5px;
  line-height: 1.58;
}

.home-search {
  width: min(880px, 100%);
  gap: 14px;
}

.search-scope-tabs {
  margin-bottom: 2px;
}

.search-box {
  min-height: 72px;
  border-color: var(--design-border-strong);
  padding: 9px 10px 9px 20px;
}

.search-box input {
  font-size: 19px;
}

.search-box button {
  min-height: 50px;
  padding: 0 23px;
}

.topic-strip,
.search-actions {
  gap: 8px;
}

.content-band {
  margin-top: 42px;
}

.topic-band {
  margin-top: 26px;
  padding-top: 42px;
}

.entry-card,
.metric-card,
.collection-card,
.resource-card,
.recent-row,
.bundle-card,
.flow-step,
.home-profile {
  border-top: 1px solid var(--design-border);
}

.entry-card::before,
.collection-card::before,
.bundle-card::before,
.flow-step::before {
  content: none;
  display: none;
}

.entry-card:hover::before,
.entry-card:focus-visible::before,
.collection-card:hover::before,
.collection-card:focus-visible::before,
.bundle-card:hover::before,
.bundle-card:focus-visible::before,
.flow-step:hover::before,
.flow-step:focus-visible::before {
  opacity: 0;
}

.entry-card,
.metric-card,
.bundle-card,
.flow-step {
  background: #FFFFFF;
}

.collection-card {
  --collection-accent: var(--design-green);
  --collection-border: rgba(94, 102, 118, 0.18);
  --collection-bg: rgba(94, 102, 118, 0.07);
  --collection-stat-bg: rgba(255, 255, 255, 0.68);
  min-height: 184px;
  gap: 13px;
  border-color: var(--collection-border);
  background: linear-gradient(145deg, var(--collection-bg), rgba(255, 255, 255, 0.82) 72%), #FFFFFF;
  box-shadow: none;
}

.collection-card:nth-child(8n+1) {
  --collection-accent: #5E6676;
  --collection-border: rgba(94, 102, 118, 0.2);
  --collection-bg: rgba(94, 102, 118, 0.08);
}

.collection-card:nth-child(8n+2) {
  --collection-accent: #9A7A53;
  --collection-border: rgba(104, 112, 134, 0.24);
  --collection-bg: rgba(104, 112, 134, 0.12);
}

.collection-card:nth-child(8n+3) {
  --collection-accent: #1F1F1F;
  --collection-border: rgba(30, 30, 30, 0.18);
  --collection-bg: rgba(30, 30, 30, 0.06);
}

.collection-card:nth-child(8n+4) {
  --collection-accent: #8A6A4B;
  --collection-border: rgba(188, 108, 37, 0.2);
  --collection-bg: rgba(188, 108, 37, 0.08);
}

.collection-card:nth-child(8n+5) {
  --collection-accent: #666A72;
  --collection-border: rgba(188, 108, 37, 0.17);
  --collection-bg: rgba(30, 30, 30, 0.2);
}

.collection-card:nth-child(8n+6) {
  --collection-accent: #5E6676;
  --collection-border: rgba(94, 102, 118, 0.18);
  --collection-bg: rgba(94, 102, 118, 0.06);
}

.collection-card:nth-child(8n+7) {
  --collection-accent: #9A7A53;
  --collection-border: rgba(104, 112, 134, 0.22);
  --collection-bg: rgba(104, 112, 134, 0.1);
}

.collection-card:nth-child(8n) {
  --collection-accent: #1F1F1F;
  --collection-border: rgba(31, 31, 31, 0.16);
  --collection-bg: rgba(30, 30, 30, 0.05);
}

.collection-card:hover,
.collection-card:focus-visible {
  border-color: rgba(31, 31, 31, 0.34);
  background: linear-gradient(145deg, var(--collection-bg), rgba(255, 255, 255, 0.74) 70%), #FFFFFF;
  box-shadow: var(--home-hover-shadow);
}

.collection-badge {
  justify-self: start;
  min-height: 25px;
  display: inline-flex;
  align-items: center;
  border: 1px solid rgba(31, 31, 31, 0.16);
  border-radius: 999px;
  padding: 0 9px;
  background: rgba(255, 255, 255, 0.64);
  color: var(--collection-accent);
  font-size: 11px;
  font-weight: 900;
  line-height: 1;
}

.collection-title {
  gap: 8px;
  padding-top: 0;
}

.collection-stat {
  border-color: rgba(255, 255, 255, 0.62);
  background: var(--collection-stat-bg);
}

.collection-cta {
  border-color: rgba(31, 31, 31, 0.88);
  background: rgba(31, 31, 31, 0.94);
}

.collection-card:hover .collection-cta,
.collection-card:focus-visible .collection-cta {
  border-color: var(--home-cta-hover);
  background: var(--home-cta-hover);
}

.bundle-card,
.bundle-card:nth-child(3n+2),
.bundle-card:nth-child(3n) {
  border-color: var(--design-border);
}

@media (max-width: 1180px) {
  .search-band {
    min-height: calc(100vh - 82px);
    min-height: calc(100svh - 82px);
    padding: 32px 0 44px;
  }
}
@media (max-width: 820px) {
  .search-band {
    min-height: min(620px, 100svh - 74px);
    align-content: center;
    gap: 16px;
    padding: 26px 0 34px;
  }
  h1 {
    font-size: 31px;
  }
  .search-copy p:last-child {
    font-size: 14.5px;
  }
  .home-search {
    gap: 11px;
  }
  .search-box {
    padding: 10px;
  }
  .search-box input {
    font-size: 16px;
  }
  .topic-strip {
    justify-content: flex-start;
    flex-wrap: nowrap;
    overflow-x: auto;
    width: 100%;
    padding-bottom: 2px;
  }
  .search-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    width: 100%;
    overflow: visible;
    padding-bottom: 0;
  }
  .secondary-action {
    width: 100%;
    min-width: 0;
  }
  .content-band {
    margin-top: 34px;
  }
  .topic-band {
    margin-top: 18px;
    padding-top: 34px;
  }
  .collection-card {
    min-height: 172px;
    gap: 12px;
  }
}
/* Review 110: fixed-height featured resource grid and balanced 8-book exposure. */
.featured-layout {
  align-items: flex-start;
  gap: 22px;
}

.recommended-grid {
  flex: 1 1 auto;
  min-width: 0;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: stretch;
  gap: 14px 14px;
}

.resource-card:not(.topic-resource-card) {
  height: 218px;
  min-height: 218px;
  display: grid;
  grid-template-rows: minmax(0, 1fr) auto;
  align-content: stretch;
  gap: 10px;
  padding: 12px;
}

.resource-main-link {
  min-height: 0;
  grid-template-columns: 84px minmax(0, 1fr);
  align-items: stretch;
  gap: 13px;
}

.cover-frame,
.cover-frame.is-placeholder {
  width: 84px;
  align-self: start;
  aspect-ratio: 2/3;
}

.resource-body {
  min-width: 0;
  min-height: 0;
  display: grid;
  grid-template-rows: 22px 60px 18px 24px;
  align-content: start;
  gap: 6px;
}

.resource-kicker {
  min-height: 22px;
  max-height: 22px;
  overflow: hidden;
}

.resource-body > strong {
  min-height: 60px;
  max-height: 60px;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  font-size: 15px;
  line-height: 1.34;
  overflow-wrap: anywhere;
}

.resource-body > em {
  min-height: 18px;
  max-height: 18px;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-height: 1.35;
}

.resource-card .badge-row {
  min-height: 24px;
  max-height: 24px;
  align-items: center;
  overflow: hidden;
}

.resource-actions {
  align-self: end;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
}

.resource-action {
  width: 100%;
  min-width: 0;
  min-height: 32px;
  padding: 0 6px;
}

.resource-action span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-rail {
  flex: 0 0 min(360px, 33%);
  width: min(360px, 33%);
}

.recent-list {
  gap: 8px;
}

.recent-row {
  min-height: 88px;
  display: grid;
  grid-template-rows: minmax(0, 1fr) auto;
}

.recent-row strong {
  min-height: 36px;
  max-height: 36px;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.recent-actions {
  align-self: end;
}

@media (max-width: 1180px) {
  .featured-layout {
    align-items: stretch;
  }
  .recent-rail {
    flex-basis: auto;
    width: 100%;
  }
}
@media (max-width: 820px) {
  .recommended-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .resource-card:not(.topic-resource-card) {
    height: 210px;
    min-height: 210px;
  }
  .resource-main-link {
    grid-template-columns: 76px minmax(0, 1fr);
    gap: 11px;
  }
  .cover-frame,
  .cover-frame.is-placeholder {
    width: 76px;
  }
  .resource-actions {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 5px;
  }
  .resource-action {
    min-height: 30px;
    padding: 0 4px;
    font-size: 10.5px;
  }
}
@media (max-width: 480px) {
  .resource-actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
/* Review 113: NAHF logo fallback cover for materials without real cover images. */
.cover-frame.is-placeholder {
  background: linear-gradient(90deg, rgba(94, 102, 118, 0.11) 0 7px, transparent 7px), linear-gradient(145deg, #FAFAFA 0%, #FFFFFF 58%, rgba(30, 30, 30, 0.26) 100%);
}

.cover-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 13px 9px 11px 15px;
  text-align: center;
}

.cover-fallback-brand {
  width: 72%;
  min-height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1px;
}

.cover-fallback-logo {
  display: block;
  width: 100%;
  max-height: 42px;
  object-fit: contain !important;
}

.cover-placeholder .placeholder-type {
  justify-self: auto;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cover-placeholder strong,
.cover-placeholder em {
  text-align: center;
}

/* Review 116: align featured and recent material section starts. */
.featured-section-actions {
  justify-content: flex-end;
  margin-bottom: 12px;
}

.featured-section-actions a {
  min-height: 36px;
}

.featured-column {
  flex: 1 1 auto;
  min-width: 0;
  display: grid;
  align-content: start;
}

.featured-column-heading,
.rail-heading {
  min-height: 54px;
  display: grid;
  align-content: start;
  gap: 2px;
  margin: 0 0 12px;
}

.featured-column-heading .eyebrow,
.rail-heading .eyebrow {
  margin: 0;
  line-height: 1.2;
}

.featured-column-heading h2,
.rail-heading h3 {
  margin: 0;
}

.rail-heading h3 {
  line-height: 1.25;
}

.recommended-grid,
.recent-list {
  margin-top: 0;
}

.recent-rail {
  align-self: flex-start;
  padding-top: 0;
}

@media (max-width: 1180px) {
  .featured-section-actions {
    margin-bottom: 12px;
  }
  .featured-column-heading,
  .rail-heading {
    min-height: auto;
    margin-bottom: 10px;
  }
  .recent-rail {
    padding-top: 18px;
  }
}
@media (max-width: 820px) {
  .featured-section-actions {
    align-items: flex-start;
  }
}
/* Review 118: charcoal-centered role tokens and CTA hierarchy. */
:host {
  --design-bg: var(--color-page-background);
  --design-surface: var(--color-card-background);
  --design-surface-muted: var(--color-surface-muted);
  --design-surface-tinted: var(--color-card-background);
  --design-text: var(--color-text-heading);
  --design-text-secondary: var(--color-text-secondary);
  --design-text-muted: var(--color-text-placeholder);
  --design-border: var(--color-border-default);
  --design-border-strong: var(--color-border-emphasis);
  --design-accent: var(--color-cta-primary-bg);
  --design-accent-strong: var(--color-cta-primary-hover);
  --design-accent-wash: var(--color-surface-selected);
  --design-green: var(--color-support-green);
  --design-clay: var(--color-support-clay);
  --design-brown-orange: var(--color-support-taupe);
  --home-cta: var(--color-cta-primary-bg);
  --home-cta-hover: var(--color-cta-primary-hover);
  --home-search-shadow: 0 10px 30px rgba(30, 30, 30, 0.055);
  --home-hover-shadow: 0 12px 30px rgba(30, 30, 30, 0.08);
  background: var(--color-page-background);
  color: var(--color-text-body);
}

.home-page {
  background: var(--color-page-background);
  color: var(--color-text-body);
}

.header-link,
.home-auth .header-link,
.home-auth .header-link:last-child,
.secondary-action,
.section-heading a,
.topic-band .section-heading a,
.featured-section-actions a,
.graph-action,
.collection-cta,
.resource-action,
.resource-action.action-original:not(.is-muted),
.recent-action,
.recent-action.action-original:not(.is-muted) {
  border-color: var(--color-cta-secondary-border);
  background: var(--color-cta-secondary-bg);
  color: var(--color-cta-secondary-text);
  box-shadow: none;
}

.home-auth .header-link[href="/signup"],
.home-auth .header-link[href="/signup"]:last-child,
.search-box button {
  border-color: var(--color-cta-primary-bg);
  background: var(--color-cta-primary-bg);
  color: var(--color-cta-primary-text);
}

.home-auth .header-link[href="/signup"]:hover,
.home-auth .header-link[href="/signup"]:focus-visible,
.search-box button:hover,
.search-box button:focus-visible {
  border-color: var(--color-cta-primary-hover);
  background: var(--color-cta-primary-hover);
  color: var(--color-cta-primary-text);
  box-shadow: var(--design-focus-ring);
}

.header-link:hover,
.header-link:focus-visible,
.home-auth .header-link:hover,
.home-auth .header-link:focus-visible,
.home-auth .header-link:last-child:hover,
.home-auth .header-link:last-child:focus-visible,
.secondary-action:hover,
.secondary-action:focus-visible,
.section-heading a:hover,
.section-heading a:focus-visible,
.topic-band .section-heading a:hover,
.topic-band .section-heading a:focus-visible,
.featured-section-actions a:hover,
.featured-section-actions a:focus-visible,
.graph-action:hover,
.graph-action:focus-visible,
.collection-card:hover .collection-cta,
.collection-card:focus-visible .collection-cta,
.resource-action:hover,
.resource-action:focus-visible,
.recent-action:hover,
.recent-action:focus-visible {
  border-color: var(--color-border-emphasis);
  background: var(--color-cta-secondary-bg);
  color: var(--color-cta-secondary-text);
  box-shadow: var(--design-focus-ring);
  transform: none;
}

.search-band {
  background: var(--color-page-background);
}

.search-box {
  border-color: var(--color-border-emphasis);
  background: var(--color-card-background);
  box-shadow: 0 10px 30px rgba(30, 30, 30, 0.055);
}

.search-box > i {
  color: var(--color-text-heading);
}

.search-box input {
  color: var(--color-text-body);
}

.search-box input::placeholder {
  color: var(--color-text-placeholder);
}

.search-box:focus-within {
  border-color: var(--color-border-emphasis);
  box-shadow: var(--design-focus-ring), 0 12px 34px rgba(30, 30, 30, 0.06);
}

.search-scope-tabs a.is-active,
.search-scope-tabs a:hover,
.search-scope-tabs a:focus-visible,
.topic-strip a:hover,
.topic-strip a:focus-visible {
  border-color: var(--color-cta-secondary-border);
  background: var(--color-surface-selected);
  color: var(--color-text-heading);
}

.topic-strip a,
.topic-strip a:nth-of-type(3n + 2),
.topic-strip a:nth-of-type(3n),
.badge-row i,
.bundle-tags i,
.resource-card .badge-row i,
.recent-feature-row i,
.resource-kicker small,
.recent-row-top i {
  border-color: var(--color-border-default);
  background: var(--color-surface-muted);
  color: var(--color-text-secondary);
}

.entry-card,
.metric-card,
.collection-card,
.resource-card:not(.topic-resource-card),
.recent-row,
.bundle-card,
.flow-step,
.home-profile {
  border-color: var(--color-border-default);
  background: var(--color-card-background);
  box-shadow: 0 10px 30px rgba(30, 30, 30, 0.045);
}

.entry-card:hover,
.entry-card:focus-visible,
.collection-card:hover,
.collection-card:focus-visible,
.resource-card:hover,
.resource-card:focus-visible,
.recent-row:hover,
.recent-row:focus-visible,
.bundle-card:hover,
.bundle-card:focus-visible,
.flow-step:hover,
.flow-step:focus-visible {
  border-color: var(--color-border-emphasis);
  background: var(--color-card-background);
  box-shadow: var(--home-hover-shadow);
}

.entry-card.tone-cream,
.metric-card.tone-cream,
.entry-card.tone-charcoal,
.metric-card.tone-charcoal,
.entry-card.tone-olive,
.metric-card.tone-olive,
.entry-card.tone-beige,
.metric-card.tone-beige,
.entry-card.tone-clay,
.metric-card.tone-clay,
.entry-card.tone-bluegrey,
.metric-card.tone-bluegrey {
  --tone-accent: var(--color-text-heading);
  --tone-border: var(--color-border-default);
  --tone-card-bg: var(--color-card-background);
  --tone-icon-bg: var(--color-surface-selected);
  --tone-pill-bg: var(--color-surface-muted);
}

.entry-label,
.metric-card small,
.bundle-kicker {
  color: var(--color-text-heading);
}

.entry-icon,
.flow-step span,
.topic-cover {
  border-color: var(--color-border-default);
  background: var(--color-surface-selected);
  color: var(--color-text-heading);
}

.collection-card,
.collection-card:nth-child(8n+1),
.collection-card:nth-child(8n+2),
.collection-card:nth-child(8n+3),
.collection-card:nth-child(8n+4),
.collection-card:nth-child(8n+5),
.collection-card:nth-child(8n+6),
.collection-card:nth-child(8n+7),
.collection-card:nth-child(8n) {
  --collection-accent: var(--color-text-heading);
  --collection-border: var(--color-border-default);
  --collection-bg: var(--color-card-background);
  --collection-stat-bg: var(--color-surface-muted);
  border-color: var(--color-border-default);
  background: var(--color-card-background);
}

.collection-card::before {
  background: var(--color-border-emphasis);
  opacity: 1;
}

.collection-badge,
.collection-stat {
  border-color: var(--color-border-default);
  background: var(--color-surface-muted);
  color: var(--color-text-secondary);
}

.cover-frame,
.cover-frame.is-placeholder {
  border-color: var(--color-border-default);
  background: var(--color-surface-muted);
}

.cover-frame.is-placeholder {
  background: linear-gradient(90deg, var(--color-border-default) 0 7px, transparent 7px), linear-gradient(145deg, var(--color-surface-muted), #FFFFFF 62%, rgba(30, 30, 30, 0.04));
}

.cover-frame.is-placeholder::before {
  border-color: var(--color-border-default);
}

.cover-placeholder .placeholder-type {
  border-color: var(--color-border-default);
  background: var(--color-card-background);
  color: var(--color-text-secondary);
}

.graph-band {
  border-color: var(--color-border-default);
  background: var(--color-card-background);
  box-shadow: 0 10px 30px rgba(30, 30, 30, 0.045);
}

/* Review 119: first-screen neutral color hierarchy. */
:host {
  --review119-page-bg: #FFFFFF;
  --review119-surface: #FFFFFF;
  --review119-charcoal: #1F1F1F;
  --review119-charcoal-hover: #111111;
  --review119-text: #252525;
  --review119-secondary-text: #4F4F4F;
  --review119-muted-text: #666666;
  --review119-border: rgba(31, 31, 31, 0.14);
  --review119-border-strong: rgba(30, 30, 30, 0.24);
  --review119-soft-bg: rgba(30, 30, 30, 0.035);
  --review119-selected-bg: rgba(30, 30, 30, 0.06);
  --review119-focus-ring: 0 0 0 3px rgba(31, 31, 31, 0.14);
  --review119-search-shadow: 0 12px 34px rgba(30, 30, 30, 0.06);
  --review119-card-shadow: 0 10px 30px rgba(30, 30, 30, 0.045);
  --design-bg: var(--review119-page-bg);
  --design-surface: var(--review119-surface);
  --design-surface-muted: var(--review119-soft-bg);
  --design-surface-tinted: var(--review119-surface);
  --design-text: var(--review119-charcoal);
  --design-text-secondary: var(--review119-secondary-text);
  --design-text-muted: var(--review119-muted-text);
  --design-border: var(--review119-border);
  --design-border-strong: var(--review119-border-strong);
  --design-accent: var(--review119-charcoal);
  --design-accent-strong: var(--review119-charcoal-hover);
  --design-accent-wash: var(--review119-selected-bg);
  --home-cta: var(--review119-charcoal);
  --home-cta-hover: var(--review119-charcoal-hover);
  --home-search-shadow: var(--review119-search-shadow);
  --home-hover-shadow: 0 12px 30px rgba(30, 30, 30, 0.08);
  background: var(--review119-page-bg);
  color: var(--review119-text);
}

:host,
.home-page {
  background: var(--review119-page-bg);
  color: var(--review119-text);
}

.home-header {
  color: var(--review119-text);
}

.primary-nav a {
  color: var(--review119-secondary-text);
}

.primary-nav a:hover,
.primary-nav a:focus-visible {
  background: var(--review119-surface);
  color: var(--review119-charcoal);
  box-shadow: var(--review119-focus-ring);
}

.header-link,
.home-auth .header-link,
.home-auth .header-link:last-child,
.home-auth .header-link[href="/login"] {
  border: 1px solid var(--review119-border);
  background: var(--review119-surface);
  color: var(--review119-secondary-text);
  box-shadow: none;
}

.home-auth .header-link[href="/signup"],
.home-auth .header-link[href="/signup"]:last-child {
  border-color: var(--review119-border-strong);
  background: var(--review119-surface);
  color: var(--review119-charcoal);
  box-shadow: inset 0 0 0 1px rgba(30, 30, 30, 0.04);
}

.header-link:hover,
.header-link:focus-visible,
.home-auth .header-link:hover,
.home-auth .header-link:focus-visible,
.home-auth .header-link:last-child:hover,
.home-auth .header-link:last-child:focus-visible {
  border-color: var(--review119-border-strong);
  background: var(--review119-selected-bg);
  color: var(--review119-charcoal);
  box-shadow: var(--review119-focus-ring);
}

.home-auth .header-link[href="/signup"]:hover,
.home-auth .header-link[href="/signup"]:focus-visible {
  border-color: var(--review119-charcoal);
  background: var(--review119-selected-bg);
  color: var(--review119-charcoal);
}

.search-band {
  border-color: transparent;
  background: var(--review119-page-bg);
  box-shadow: none;
}

.search-copy .eyebrow {
  border-color: var(--review119-border);
  background: var(--review119-surface);
  color: var(--review119-secondary-text);
}

h1 {
  color: var(--review119-charcoal);
  font-size: 44px;
}

.search-copy p:last-child {
  color: var(--review119-secondary-text);
}

.search-scope-tabs a {
  border-color: transparent;
  background: transparent;
  color: var(--review119-muted-text);
}

.search-scope-tabs a.is-active,
.search-scope-tabs a:hover,
.search-scope-tabs a:focus-visible {
  border-color: var(--review119-border);
  background: var(--review119-surface);
  color: var(--review119-charcoal);
  outline: none;
}

.search-box {
  border-color: var(--review119-border-strong);
  background: var(--review119-surface);
  box-shadow: var(--review119-search-shadow);
}

.search-box > i,
.search-box input {
  color: var(--review119-charcoal);
}

.search-box input::placeholder {
  color: rgba(30, 30, 30, 0.52);
}

.search-box:focus-within {
  border-color: var(--review119-charcoal);
  box-shadow: var(--review119-focus-ring), var(--review119-search-shadow);
}

.search-box button {
  border-color: var(--review119-charcoal);
  background: var(--review119-charcoal);
  color: #FFFFFF;
  box-shadow: none;
}

.search-box button:hover,
.search-box button:focus-visible {
  border-color: var(--review119-charcoal-hover);
  background: var(--review119-charcoal-hover);
  color: #FFFFFF;
  box-shadow: var(--review119-focus-ring);
}

.topic-strip > span {
  color: var(--review119-secondary-text);
}

.topic-strip a,
.topic-strip a:nth-of-type(3n + 2),
.topic-strip a:nth-of-type(3n),
.badge-row i,
.bundle-tags i,
.resource-card .badge-row i,
.recent-feature-row i,
.resource-kicker small,
.recent-row-top i {
  border-color: var(--review119-border);
  background: var(--review119-surface);
  color: var(--review119-secondary-text);
  box-shadow: none;
}

.topic-strip a:hover,
.topic-strip a:focus-visible {
  border-color: var(--review119-border-strong);
  background: var(--review119-selected-bg);
  color: var(--review119-charcoal);
  box-shadow: none;
}

.secondary-action,
.section-heading a,
.topic-band .section-heading a,
.featured-section-actions a,
.graph-action,
.collection-cta,
.resource-action,
.resource-action.action-body,
.resource-action.action-graph,
.resource-action.action-topic,
.resource-action.action-original:not(.is-muted),
.recent-action,
.recent-action.action-body,
.recent-action.action-graph,
.recent-action.action-topic,
.recent-action.action-original:not(.is-muted) {
  border-color: var(--review119-border);
  background: var(--review119-surface);
  color: var(--review119-secondary-text);
  box-shadow: none;
}

.secondary-action:hover,
.secondary-action:focus-visible,
.section-heading a:hover,
.section-heading a:focus-visible,
.topic-band .section-heading a:hover,
.topic-band .section-heading a:focus-visible,
.featured-section-actions a:hover,
.featured-section-actions a:focus-visible,
.graph-action:hover,
.graph-action:focus-visible,
.collection-card:hover .collection-cta,
.collection-card:focus-visible .collection-cta,
.resource-action:hover,
.resource-action:focus-visible,
.recent-action:hover,
.recent-action:focus-visible {
  border-color: var(--review119-border-strong);
  background: var(--review119-selected-bg);
  color: var(--review119-charcoal);
  box-shadow: var(--review119-focus-ring);
  transform: none;
}

.entry-card,
.metric-card,
.collection-card,
.resource-card:not(.topic-resource-card),
.recent-row,
.bundle-card,
.flow-step,
.home-profile,
.graph-band {
  border-color: var(--review119-border);
  background: var(--review119-surface);
  box-shadow: var(--review119-card-shadow);
}

.collection-card,
.collection-card:nth-child(8n+1),
.collection-card:nth-child(8n+2),
.collection-card:nth-child(8n+3),
.collection-card:nth-child(8n+4),
.collection-card:nth-child(8n+5),
.collection-card:nth-child(8n+6),
.collection-card:nth-child(8n+7),
.collection-card:nth-child(8n) {
  --collection-accent: var(--review119-charcoal);
  --collection-border: var(--review119-border);
  --collection-bg: var(--review119-surface);
  --collection-stat-bg: var(--review119-soft-bg);
  border-color: var(--review119-border);
  background: var(--review119-surface);
}

.collection-badge,
.collection-stat,
.entry-icon,
.flow-step span,
.topic-cover {
  border-color: var(--review119-border);
  background: var(--review119-soft-bg);
  color: var(--review119-charcoal);
}

@media (max-width: 820px) {
  h1 {
    font-size: 31px;
  }
}
/* Review 120: calm topic and material card hierarchy. */
:host {
  --review120-card-border: rgba(30, 30, 30, 0.12);
  --review120-card-border-hover: rgba(31, 31, 31, 0.14);
  --review120-card-shadow: 0 6px 18px rgba(30, 30, 30, 0.035);
  --review120-card-shadow-hover: 0 8px 22px rgba(30, 30, 30, 0.055);
  --review120-charcoal: #1F1F1F;
  --review120-charcoal-hover: #111111;
  --review120-muted-text: #4F4F4F;
  --review120-badge-bg: rgba(30, 30, 30, 0.035);
  --review120-selected-bg: rgba(30, 30, 30, 0.06);
}

.collection-card,
.collection-card:nth-child(8n+1),
.collection-card:nth-child(8n+2),
.collection-card:nth-child(8n+3),
.collection-card:nth-child(8n+4),
.collection-card:nth-child(8n+5),
.collection-card:nth-child(8n+6),
.collection-card:nth-child(8n+7),
.collection-card:nth-child(8n),
.resource-card:not(.topic-resource-card),
.recent-row {
  border-color: var(--review120-card-border);
  border-top-width: 1px;
  background: #FFFFFF;
  box-shadow: var(--review120-card-shadow);
}

.collection-card::before {
  display: none;
}

.collection-card {
  --collection-tint: rgba(93, 119, 139, 0.09);
  --collection-stat-bg: var(--collection-tint);
}

.collection-card:nth-child(8n+1) {
  --collection-tint: rgba(93, 119, 139, 0.09);
}

.collection-card:nth-child(8n+2) {
  --collection-tint: rgba(120, 146, 124, 0.09);
}

.collection-card:nth-child(8n+3) {
  --collection-tint: rgba(102, 102, 102, 0.09);
}

.collection-card:nth-child(8n+4) {
  --collection-tint: rgba(102, 102, 102, 0.09);
}

.collection-card:nth-child(8n+5) {
  --collection-tint: rgba(105, 130, 117, 0.085);
}

.collection-card:nth-child(8n+6) {
  --collection-tint: rgba(102, 102, 102, 0.09);
}

.collection-card:nth-child(8n+7) {
  --collection-tint: rgba(116, 133, 152, 0.085);
}

.collection-card:nth-child(8n) {
  --collection-tint: rgba(102, 106, 114, 0.085);
}

.collection-card:hover,
.collection-card:focus-visible,
.resource-card:hover,
.resource-card:focus-visible,
.recent-row:hover,
.recent-row:focus-visible {
  border-color: var(--review120-card-border-hover);
  background: #FFFFFF;
  box-shadow: var(--review120-card-shadow-hover);
}

.collection-badge,
.collection-stat,
.resource-kicker small,
.recent-row-top i,
.badge-row i,
.bundle-tags i,
.resource-card .badge-row i,
.recent-feature-row i {
  border-color: rgba(30, 30, 30, 0.1);
  background: var(--review120-badge-bg);
  color: var(--review120-muted-text);
  box-shadow: none;
}

.collection-badge,
.collection-stat {
  background: var(--collection-tint);
  color: var(--review120-charcoal);
}

.collection-cta,
.resource-action,
.recent-action,
.resource-action.action-body,
.resource-action.action-graph,
.resource-action.action-topic,
.recent-action.action-body,
.recent-action.action-graph,
.recent-action.action-topic {
  border-color: rgba(31, 31, 31, 0.14);
  background: #FFFFFF;
  color: var(--review120-charcoal);
  box-shadow: none;
}

.resource-action.action-original:not(.is-muted),
.recent-action.action-original:not(.is-muted) {
  border-color: var(--review120-charcoal);
  background: var(--review120-charcoal);
  color: #FFFFFF;
}

.collection-cta:hover,
.collection-cta:focus-visible,
.resource-action:hover,
.resource-action:focus-visible,
.recent-action:hover,
.recent-action:focus-visible {
  border-color: rgba(30, 30, 30, 0.22);
  background: var(--review120-selected-bg);
  color: var(--review120-charcoal);
  box-shadow: var(--review119-focus-ring, 0 0 0 3px rgba(31, 31, 31, 0.14));
  transform: none;
}

.resource-action.action-original:not(.is-muted):hover,
.resource-action.action-original:not(.is-muted):focus-visible,
.recent-action.action-original:not(.is-muted):hover,
.recent-action.action-original:not(.is-muted):focus-visible {
  border-color: var(--review120-charcoal-hover);
  background: var(--review120-charcoal-hover);
  color: #FFFFFF;
}

.resource-action.is-muted,
.recent-action.is-muted {
  border-color: rgba(30, 30, 30, 0.1);
  background: rgba(30, 30, 30, 0.025);
  color: rgba(30, 30, 30, 0.46);
}

/* Review 122: clean white page tone and reduced secondary CTA weight. */
:host {
  --review122-page-bg: #FFFFFF;
  --review122-card-bg: #FFFFFF;
  --review122-text: #1F1F1F;
  --review122-body: #2B2B2B;
  --review122-secondary: #666666;
  --review122-muted: #8A8A8A;
  --review122-border: #E5E5E5;
  --review122-border-strong: #D8D8D8;
  --review122-muted-bg: #FAFAFA;
  --review122-selected-bg: #F7F7F7;
  --review122-focus: 0 0 0 3px rgba(31, 31, 31, 0.14);
  --review122-card-shadow: 0 6px 18px rgba(30, 30, 30, 0.032);
  --review122-card-shadow-hover: 0 8px 22px rgba(30, 30, 30, 0.05);
  --review122-topic-blue: #536C7A;
  --review122-topic-green: #5E6676;
  --review122-topic-mauve: #666666;
  --review122-topic-slate: #687086;
  --design-bg: var(--review122-page-bg);
  --design-surface: var(--review122-card-bg);
  --design-surface-muted: var(--review122-muted-bg);
  --design-surface-tinted: var(--review122-card-bg);
  --design-text: var(--review122-text);
  --design-text-secondary: var(--review122-secondary);
  --design-text-muted: var(--review122-muted);
  --design-border: var(--review122-border);
  --design-border-strong: var(--review122-border-strong);
  --design-accent: var(--review122-text);
  --design-accent-strong: #111111;
  --design-accent-wash: var(--review122-selected-bg);
  --design-green: var(--review122-topic-green);
  --design-clay: var(--review122-topic-mauve);
  --home-cta: var(--review122-text);
  --home-cta-hover: #111111;
  --home-search-shadow: 0 10px 26px rgba(30, 30, 30, 0.055);
  --home-hover-shadow: var(--review122-card-shadow-hover);
  background: var(--review122-page-bg);
  color: var(--review122-body);
}

:host,
.home-page,
.search-band {
  background: var(--review122-page-bg);
  color: var(--review122-body);
}

.search-band {
  border-color: transparent;
  box-shadow: none;
}

.search-copy .eyebrow,
.search-scope-tabs a.is-active,
.search-scope-tabs a:hover,
.search-scope-tabs a:focus-visible,
.topic-strip a:hover,
.topic-strip a:focus-visible {
  border-color: var(--review122-border);
  background: var(--review122-card-bg);
  color: var(--review122-text);
  box-shadow: none;
}

.header-link,
.home-auth .header-link,
.home-auth .header-link:last-child,
.home-auth .header-link[href="/login"],
.home-auth .header-link[href="/signup"],
.home-auth .header-link[href="/signup"]:last-child,
.secondary-action,
.section-heading a,
.featured-section-actions a,
.graph-action,
.collection-cta,
.resource-action,
.resource-action.action-original:not(.is-muted),
.recent-action,
.recent-action.action-original:not(.is-muted) {
  border-color: var(--review122-border);
  background: var(--review122-card-bg);
  color: var(--review122-text);
  box-shadow: none;
}

.home-auth .header-link[href="/signup"],
.home-auth .header-link[href="/signup"]:last-child {
  border-color: var(--review122-border-strong);
  background: var(--review122-muted-bg);
}

.header-link:hover,
.header-link:focus-visible,
.home-auth .header-link:hover,
.home-auth .header-link:focus-visible,
.secondary-action:hover,
.secondary-action:focus-visible,
.section-heading a:hover,
.section-heading a:focus-visible,
.featured-section-actions a:hover,
.featured-section-actions a:focus-visible,
.graph-action:hover,
.graph-action:focus-visible,
.resource-action:hover,
.resource-action:focus-visible,
.recent-action:hover,
.recent-action:focus-visible,
.collection-card:hover .collection-cta,
.collection-card:focus-visible .collection-cta {
  border-color: var(--review122-border-strong);
  background: var(--review122-selected-bg);
  color: var(--review122-text);
  box-shadow: var(--review122-focus);
  transform: none;
}

.search-box {
  border-color: var(--review122-border-strong);
  background: var(--review122-card-bg);
  box-shadow: var(--home-search-shadow);
}

.search-box:focus-within {
  border-color: var(--review122-text);
  box-shadow: var(--review122-focus), var(--home-search-shadow);
}

.search-box > i,
.search-box input {
  color: var(--review122-text);
}

.search-box input::placeholder {
  color: rgba(30, 30, 30, 0.52);
}

.search-box button {
  border-color: var(--review122-text);
  background: var(--review122-text);
  color: #FFFFFF;
  box-shadow: none;
}

.search-box button:hover,
.search-box button:focus-visible {
  border-color: #111111;
  background: #111111;
  color: #FFFFFF;
  box-shadow: var(--review122-focus);
}

.entry-card,
.metric-card,
.collection-card,
.resource-card:not(.topic-resource-card),
.recent-row,
.bundle-card,
.flow-step,
.graph-band,
.home-profile {
  border-color: var(--review122-border);
  background: var(--review122-card-bg);
  box-shadow: var(--review122-card-shadow);
}

.entry-card:hover,
.entry-card:focus-visible,
.collection-card:hover,
.collection-card:focus-visible,
.resource-card:hover,
.resource-card:focus-visible,
.recent-row:hover,
.recent-row:focus-visible,
.bundle-card:hover,
.bundle-card:focus-visible,
.flow-step:hover,
.flow-step:focus-visible {
  border-color: var(--review122-border-strong);
  background: var(--review122-card-bg);
  box-shadow: var(--review122-card-shadow-hover);
}

.collection-card,
.collection-card:nth-child(8n+1) {
  --collection-accent: var(--review122-topic-blue);
  --collection-tint: rgba(83, 108, 122, 0.09);
}

.collection-card:nth-child(8n+2),
.collection-card:nth-child(8n+5) {
  --collection-accent: var(--review122-topic-green);
  --collection-tint: rgba(94, 102, 118, 0.09);
}

.collection-card:nth-child(8n+3),
.collection-card:nth-child(8n+7) {
  --collection-accent: var(--review122-topic-slate);
  --collection-tint: rgba(104, 112, 134, 0.085);
}

.collection-card:nth-child(8n+4),
.collection-card:nth-child(8n) {
  --collection-accent: var(--review122-topic-mauve);
  --collection-tint: rgba(102, 102, 102, 0.085);
}

.collection-card:nth-child(8n+6) {
  --collection-accent: #666A72;
  --collection-tint: rgba(102, 106, 114, 0.085);
}

.collection-badge,
.collection-stat {
  border-color: rgba(30, 30, 30, 0.1);
  background: var(--collection-tint);
  color: var(--review122-text);
}

.entry-icon,
.flow-step span,
.topic-cover,
.topic-strip a,
.badge-row i,
.bundle-tags i,
.resource-card .badge-row i,
.recent-feature-row i,
.resource-kicker small,
.recent-row-top i {
  border-color: rgba(30, 30, 30, 0.1);
  background: var(--review122-muted-bg);
  color: var(--review122-secondary);
  box-shadow: none;
}

.resource-action.is-muted,
.recent-action.is-muted {
  border-color: rgba(30, 30, 30, 0.1);
  background: rgba(30, 30, 30, 0.025);
  color: rgba(30, 30, 30, 0.46);
  cursor: default;
}

.cover-frame,
.cover-frame.is-placeholder {
  border-color: var(--review122-border);
  background: var(--review122-muted-bg);
}

/* Review 124: CTA and card action hierarchy. */
:host {
  --review124-primary: #1F1F1F;
  --review124-primary-hover: #343434;
  --review124-primary-text: #FFFFFF;
  --review124-secondary-bg: #FFFFFF;
  --review124-secondary-border: #E5E5E5;
  --review124-secondary-hover: #F7F7F7;
  --review124-chip-bg: #F6F6F6;
  --review124-chip-text: #2B2B2B;
  --review124-chip-border: #EEEEEE;
  --review124-disabled-bg: #F5F5F5;
  --review124-disabled-border: #E5E5E5;
  --review124-disabled-text: #A0A0A0;
  --home-cta: var(--review124-primary);
  --home-cta-hover: var(--review124-primary-hover);
  --design-accent: var(--review124-primary);
  --design-accent-strong: var(--review124-primary-hover);
}

.header-link,
.home-auth .header-link,
.home-auth .header-link:last-child,
.home-auth .header-link[href="/login"],
.secondary-action,
.section-heading a,
.topic-band .section-heading a,
.featured-section-actions a,
.graph-action,
.collection-cta {
  border-color: var(--review124-secondary-border);
  background: var(--review124-secondary-bg);
  color: var(--review124-primary);
  box-shadow: none;
}

.home-auth .header-link[href="/signup"],
.home-auth .header-link[href="/signup"]:last-child,
.search-box button {
  border-color: var(--review124-primary);
  background: var(--review124-primary);
  color: var(--review124-primary-text);
  box-shadow: none;
}

.header-link:hover,
.header-link:focus-visible,
.home-auth .header-link:hover,
.home-auth .header-link:focus-visible,
.home-auth .header-link:last-child:hover,
.home-auth .header-link:last-child:focus-visible,
.secondary-action:hover,
.secondary-action:focus-visible,
.section-heading a:hover,
.section-heading a:focus-visible,
.topic-band .section-heading a:hover,
.topic-band .section-heading a:focus-visible,
.featured-section-actions a:hover,
.featured-section-actions a:focus-visible,
.graph-action:hover,
.graph-action:focus-visible,
.collection-card:hover .collection-cta,
.collection-card:focus-visible .collection-cta {
  border-color: var(--review124-secondary-border);
  background: var(--review124-secondary-hover);
  color: var(--review124-primary);
  box-shadow: 0 0 0 3px rgba(30, 30, 30, 0.12);
  transform: none;
}

.home-auth .header-link[href="/signup"]:hover,
.home-auth .header-link[href="/signup"]:focus-visible,
.search-box button:hover,
.search-box button:focus-visible {
  border-color: var(--review124-primary-hover);
  background: var(--review124-primary-hover);
  color: var(--review124-primary-text);
  box-shadow: 0 0 0 3px rgba(31, 31, 31, 0.14);
}

.topic-strip a,
.topic-strip a:nth-of-type(3n + 2),
.topic-strip a:nth-of-type(3n),
.badge-row i,
.bundle-tags i,
.resource-card .badge-row i,
.recent-feature-row i,
.resource-kicker small,
.recent-row-top i {
  border-color: var(--review124-chip-border);
  background: var(--review124-chip-bg);
  color: var(--review124-chip-text);
  box-shadow: none;
}

.topic-strip a:hover,
.topic-strip a:focus-visible {
  border-color: var(--review124-secondary-border);
  background: var(--review124-secondary-hover);
  color: var(--review124-primary);
  box-shadow: 0 0 0 3px rgba(30, 30, 30, 0.1);
}

.resource-action,
.resource-action.action-body,
.resource-action.action-graph,
.resource-action.action-topic,
.resource-action.action-original:not(.is-muted),
.recent-action,
.recent-action.action-body,
.recent-action.action-graph,
.recent-action.action-topic,
.recent-action.action-original:not(.is-muted) {
  min-height: 30px;
  border-color: var(--review124-secondary-border);
  background: var(--review124-secondary-bg);
  color: var(--review124-primary);
  font-size: 11.5px;
  font-weight: 760;
  box-shadow: none;
}

.resource-action:hover,
.resource-action:focus-visible,
.recent-action:hover,
.recent-action:focus-visible {
  border-color: var(--review124-primary);
  background: var(--review124-primary);
  color: var(--review124-primary-text);
  box-shadow: 0 0 0 3px rgba(30, 30, 30, 0.12);
  transform: none;
}

.resource-action.is-muted,
.recent-action.is-muted {
  border-color: var(--review124-disabled-border);
  background: var(--review124-disabled-bg);
  color: var(--review124-disabled-text);
  box-shadow: none;
  cursor: default;
}

/* Review 125: refined topic collection card hierarchy. */
:host {
  --review125-card-shadow: 0 2px 10px rgba(30, 30, 30, 0.035);
  --review125-card-shadow-hover: 0 6px 18px rgba(30, 30, 30, 0.055);
  --review125-text: #1F1F1F;
  --review125-muted-text: #5F625F;
}

.collection-grid {
  gap: 16px;
  align-items: stretch;
}

.collection-card,
.collection-card:nth-child(8n+1),
.collection-card:nth-child(8n+2),
.collection-card:nth-child(8n+3),
.collection-card:nth-child(8n+4),
.collection-card:nth-child(8n+5),
.collection-card:nth-child(8n+6),
.collection-card:nth-child(8n+7),
.collection-card:nth-child(8n) {
  --collection-bg: #F3F5F5;
  --collection-border: #DDE5E5;
  --collection-accent: #5C6969;
  --collection-stat-bg: rgba(255, 255, 255, 0.74);
  --collection-stat-border: rgba(30, 30, 30, 0.08);
  min-height: 212px;
  height: 100%;
  display: grid;
  grid-template-rows: auto auto minmax(10px, 1fr) auto;
  gap: 14px;
  overflow: hidden;
  border-color: var(--collection-border);
  border-top: 1px solid var(--collection-border);
  padding: 20px;
  background: var(--collection-bg);
  box-shadow: var(--review125-card-shadow);
  transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.collection-card.topic-dokdo {
  --collection-bg: #FFFFFF;
  --collection-border: #E5E5E5;
  --collection-accent: #536C7A;
}

.collection-card.topic-balhae {
  --collection-bg: #FFFFFF;
  --collection-border: #E5E5E5;
  --collection-accent: #5E6676;
}

.collection-card.topic-goguryeo {
  --collection-bg: #FFFFFF;
  --collection-border: #E5E5E5;
  --collection-accent: #5E6676;
}

.collection-card.topic-northeast-project {
  --collection-bg: #FFFFFF;
  --collection-border: #E5E5E5;
  --collection-accent: #5E6676;
}

.collection-card.topic-comfort-women {
  --collection-bg: #FFFFFF;
  --collection-border: #E5E5E5;
  --collection-accent: #666666;
}

.collection-card.topic-korea-japan-talks {
  --collection-bg: #FFFFFF;
  --collection-border: #E5E5E5;
  --collection-accent: #536C7A;
}

.collection-card.topic-gando-border {
  --collection-bg: #F3F5F5;
  --collection-border: #DDE5E5;
  --collection-accent: #5C6969;
}

.collection-card.topic-japanese-intrusion {
  --collection-bg: #FFFFFF;
  --collection-border: #E5E5E5;
  --collection-accent: #666666;
}

.collection-card::before,
.collection-card:hover::before,
.collection-card:focus-visible::before {
  content: none;
  display: none;
  opacity: 0;
}

.collection-card:hover,
.collection-card:focus-visible {
  border-color: var(--collection-border);
  background: var(--collection-bg);
  box-shadow: var(--review125-card-shadow-hover);
  outline: none;
  transform: none;
}

.collection-card > .collection-badge {
  display: none;
}

.collection-title {
  grid-row: 1;
  display: grid;
  gap: 8px;
  min-width: 0;
  padding-top: 0;
}

.collection-card strong {
  color: var(--review125-text);
  font-size: 20px;
  font-weight: 820;
  line-height: 1.22;
  letter-spacing: 0;
}

.collection-title em {
  min-height: 38px;
  max-height: 38px;
  display: -webkit-box;
  overflow: hidden;
  color: var(--review125-muted-text);
  font-size: 13.2px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.42;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.collection-stat-list {
  grid-row: 2;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  min-width: 0;
}

.collection-stat {
  min-width: 0;
  min-height: 58px;
  display: grid;
  align-content: center;
  gap: 4px;
  border: 1px solid var(--collection-stat-border);
  border-radius: 7px;
  padding: 8px 9px;
  background: var(--collection-stat-bg);
  color: var(--review125-text);
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.62);
}

.collection-stat b {
  overflow: hidden;
  color: var(--review125-text);
  font-size: 16px;
  font-variant-numeric: tabular-nums;
  font-weight: 800;
  line-height: 1.1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.collection-stat span {
  color: var(--review125-muted-text);
  font-size: 11.5px;
  font-weight: 680;
  line-height: 1.15;
}

.collection-card-footer {
  grid-row: 4;
  align-self: end;
  display: flex;
  justify-content: flex-start;
  min-width: 0;
}

.collection-cta {
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid var(--collection-border);
  border-radius: 7px;
  padding: 0 12px;
  background: rgba(255, 255, 255, 0.34);
  color: var(--collection-accent);
  box-shadow: none;
  font-size: 12.5px;
  font-weight: 740;
  line-height: 1;
}

.collection-card:hover .collection-cta,
.collection-card:focus-visible .collection-cta,
.collection-cta:hover,
.collection-cta:focus-visible {
  border-color: var(--collection-accent);
  background: rgba(255, 255, 255, 0.58);
  color: var(--collection-accent);
  box-shadow: none;
  transform: none;
}

@media (max-width: 1100px) {
  .collection-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 640px) {
  .collection-grid {
    grid-template-columns: 1fr;
  }
  .collection-card,
  .collection-card:nth-child(8n+1),
  .collection-card:nth-child(8n+2),
  .collection-card:nth-child(8n+3),
  .collection-card:nth-child(8n+4),
  .collection-card:nth-child(8n+5),
  .collection-card:nth-child(8n+6),
  .collection-card:nth-child(8n+7),
  .collection-card:nth-child(8n) {
    min-height: 198px;
    padding: 18px;
  }
}
/* Review 126: book-first material cards with quiet outline actions. */
:host {
  --review126-action-bg: #FFFFFF;
  --review126-action-border: #E5E5E5;
  --review126-action-text: #1F1F1F;
  --review126-action-hover-bg: #F7F7F7;
  --review126-action-disabled-bg: #F5F5F5;
  --review126-action-disabled-text: #A0A0A0;
  --review126-action-disabled-border: #E5E5E5;
  --review126-chip-bg: #F6F6F6;
  --review126-chip-border: #EEEEEE;
  --review126-muted-text: #686864;
}

.resource-card:not(.topic-resource-card) {
  height: 226px;
  min-height: 226px;
  gap: 9px;
  padding: 12px;
}

.resource-main-link {
  grid-template-columns: 92px minmax(0, 1fr);
  gap: 13px;
}

.cover-frame,
.cover-frame.is-placeholder {
  width: 92px;
  border-color: var(--review126-action-disabled-border);
  background: #FAFAFA;
  box-shadow: 0 7px 16px rgba(30, 30, 30, 0.07);
}

.resource-body {
  grid-template-rows: 61px 35px 24px;
  gap: 6px;
}

.resource-body > strong {
  min-height: 61px;
  max-height: 61px;
  color: #171717;
  font-size: 15px;
  line-height: 1.35;
  -webkit-line-clamp: 3;
}

.resource-meta-line,
.recent-meta-line {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
  overflow: hidden;
  color: var(--review126-muted-text);
}

.resource-meta-line {
  min-height: 35px;
  max-height: 35px;
}

.resource-meta-line em,
.recent-meta-line em {
  min-width: 0;
  flex: 1 1 100%;
  overflow: hidden;
  color: var(--review126-muted-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 680;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.resource-meta-line i,
.resource-meta-line small,
.recent-meta-line i,
.recent-meta-line small,
.resource-card .badge-row i,
.recent-row-top i {
  border-color: var(--review126-chip-border);
  background: var(--review126-chip-bg);
  color: var(--review126-muted-text);
  box-shadow: none;
}

.resource-meta-line i,
.resource-meta-line small,
.recent-meta-line i,
.recent-meta-line small {
  min-height: 18px;
  padding: 2px 6px;
  font-size: 10.5px;
  font-style: normal;
  font-weight: 680;
  line-height: 1.25;
}

.resource-card .badge-row {
  min-height: 22px;
  max-height: 22px;
  gap: 4px;
}

.resource-card .badge-row i {
  padding: 2px 6px;
  font-size: 10.5px;
  font-weight: 680;
}

.resource-actions {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 5px;
}

.resource-action,
.resource-action.action-body,
.resource-action.action-graph,
.resource-action.action-topic,
.resource-action.action-original:not(.is-muted),
.recent-action,
.recent-action.action-graph,
.recent-action.action-original:not(.is-muted) {
  min-height: 28px;
  border-color: var(--review126-action-border);
  border-radius: 7px;
  padding: 0 6px;
  background: var(--review126-action-bg);
  color: var(--review126-action-text);
  font-size: 11px;
  font-weight: 680;
  box-shadow: none;
}

.resource-action i,
.recent-action i {
  font-size: 10.5px;
}

.resource-action:hover,
.resource-action:focus-visible,
.recent-action:hover,
.recent-action:focus-visible,
.resource-action.action-original:not(.is-muted):hover,
.resource-action.action-original:not(.is-muted):focus-visible,
.recent-action.action-original:not(.is-muted):hover,
.recent-action.action-original:not(.is-muted):focus-visible {
  border-color: var(--review126-action-border);
  background: var(--review126-action-hover-bg);
  color: var(--review126-action-text);
  box-shadow: 0 0 0 2px rgba(30, 30, 30, 0.08);
  transform: none;
}

.resource-action.is-muted,
.recent-action.is-muted {
  border-color: var(--review126-action-disabled-border);
  background: var(--review126-action-disabled-bg);
  color: var(--review126-action-disabled-text);
  box-shadow: none;
}

.recent-row {
  min-height: 116px;
  padding: 10px;
  gap: 8px;
}

.recent-row-link {
  display: grid;
  grid-template-columns: 50px minmax(0, 1fr);
  align-items: start;
  gap: 10px;
}

.recent-cover-frame {
  position: relative;
  display: block;
  overflow: hidden;
  width: 50px;
  aspect-ratio: 2/3;
  border: 1px solid var(--review126-action-disabled-border);
  border-radius: 5px;
  background: #FAFAFA;
  box-shadow: 0 5px 12px rgba(30, 30, 30, 0.06);
}

.recent-cover-frame img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.recent-cover-frame.is-placeholder {
  background: linear-gradient(90deg, rgba(94, 102, 118, 0.1) 0 5px, transparent 5px), linear-gradient(145deg, #FAFAFA, #FFFFFF 62%, rgba(30, 30, 30, 0.12));
}

.recent-cover-frame .cover-placeholder {
  gap: 3px;
  padding: 7px 6px 6px 9px;
}

.recent-cover-frame .cover-fallback-logo {
  max-width: 24px;
  max-height: 12px;
}

.recent-cover-frame .placeholder-type,
.recent-cover-frame .cover-placeholder strong,
.recent-cover-frame .cover-placeholder em {
  display: none;
}

.recent-copy {
  display: grid;
  min-width: 0;
  gap: 5px;
}

.recent-copy strong,
.recent-row strong {
  min-height: 36px;
  max-height: 36px;
  color: #171717;
  font-size: 13.5px;
  font-weight: 820;
  line-height: 1.33;
  -webkit-line-clamp: 2;
}

.recent-meta-line {
  min-height: 32px;
  max-height: 32px;
}

.recent-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 5px;
  padding-left: 60px;
}

.recent-action {
  width: 100%;
  min-width: 0;
}

.recent-action span,
.resource-action span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Review 127: browser pass cleanup for neutral focus and collection cards. */
.search-box input:focus {
  outline: none;
  box-shadow: none;
  --tw-ring-color: transparent;
  --tw-ring-shadow: 0 0 #0000;
}

.collection-card,
.collection-card:nth-child(8n+1),
.collection-card:nth-child(8n+2),
.collection-card:nth-child(8n+3),
.collection-card:nth-child(8n+4),
.collection-card:nth-child(8n+5),
.collection-card:nth-child(8n+6),
.collection-card:nth-child(8n+7),
.collection-card:nth-child(8n) {
  --collection-bg: #FFFFFF;
  --collection-border: #E5E5E5;
  --collection-stat-bg: #FAFAFA;
  --collection-stat-border: #E5E5E5;
  background: #FFFFFF;
}

.collection-card.topic-dokdo,
.collection-card.topic-korea-japan-talks {
  --collection-accent: #536C7A;
}

.collection-card.topic-balhae,
.collection-card.topic-gando-border {
  --collection-accent: #5E6676;
}

.collection-card.topic-goguryeo,
.collection-card.topic-northeast-project {
  --collection-accent: #5E6676;
}

.collection-card.topic-comfort-women,
.collection-card.topic-japanese-intrusion {
  --collection-accent: #666666;
}

.collection-card:hover,
.collection-card:focus-visible {
  background: #FFFFFF;
}

@media (max-width: 1180px) {
  .recent-row {
    min-height: 112px;
  }
}
@media (max-width: 820px) {
  .resource-card:not(.topic-resource-card) {
    height: auto;
    min-height: 206px;
  }
  .resource-main-link {
    grid-template-columns: 78px minmax(0, 1fr);
    gap: 11px;
  }
  .cover-frame,
  .cover-frame.is-placeholder {
    width: 78px;
  }
  .resource-actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 420px) {
  .recent-actions {
    padding-left: 0;
  }
}
/* Review 157 common UI */
:host {
  --design-bg: #FFFFFF;
  --design-surface: #FFFFFF;
  --design-surface-muted: #F5F5F5;
  --design-surface-tinted: #F5F5F5;
  --design-text: #222222;
  --design-text-secondary: #666666;
  --design-accent: #2B2B2B;
  --design-accent-strong: #171717;
  --design-accent-wash: #F5F5F5;
  --design-focus-ring: 0 0 0 3px rgba(43, 43, 43, 0.2);
  --design-shadow: 0 1px 2px rgba(30, 30, 30, 0.06);
  --design-shadow-strong: 0 2px 6px rgba(30, 30, 30, 0.08);
  background: #FFFFFF;
  color: #333333;
  font-size: 16px;
  line-height: 1.6;
}

.home-page {
  max-width: 100%;
  overflow-x: clip;
  background: #FFFFFF;
}

:host h1,
:host h2,
:host h3,
:host strong {
  font-weight: 700;
}

:host p,
:host li,
:host label,
:host input,
:host select {
  font-size: max(15px, 1em);
  font-weight: 400;
}

:host button,
:host label {
  font-weight: 600;
}

.search-band,
.content-band,
.resource-card,
.recent-rail,
.graph-band,
.collection-card,
.status-panel {
  background: #FFFFFF;
  background-image: none;
  box-shadow: 0 1px 2px rgba(30, 30, 30, 0.06);
}

.topic-strip,
.metric-strip,
.search-scope-tabs {
  background: #F5F5F5;
  background-image: none;
}

.search-actions button[type=submit],
.graph-action,
.primary-action,
.search-scope-tabs button.active {
  border-color: #2B2B2B;
  background: #2B2B2B;
  background-image: none;
  color: #FFFFFF;
}

.secondary-action,
.header-link,
.resource-action,
.recent-action {
  border-color: #BDBDBD;
  background: #FFFFFF;
  background-image: none;
  color: #2B2B2B;
}

:host button:disabled,
:host input:disabled,
:host select:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

@media (max-width: 768px) {
  .home-page {
    padding-inline: 18px;
  }
}
@media (max-width: 420px) {
  .home-page {
    padding-inline: 14px;
  }
}`],
})
export class PageHomeComponent implements OnInit {
    public loading: boolean = true;
    public errorMessage: string = "";
    public searchQuery: string = "";
    public books: HomeBook[] = [];
    public collections: HomeCollection[] = [];
    public stats: any = {};
    public accessScope: string = "";
    public fallbackCoverLogoSrc: string = "/assets/brand/logo_nahf.png";

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadOverview();
        await this.service.render();
    }

    public async loadOverview() {
        this.loading = true;
        this.errorMessage = "";
        await this.service.render();

        try {
            let response: any = await this.withTimeout(this.fetchMainBooks(), 45000);
            if (response.code !== 200) {
                this.errorMessage = "";
                this.books = [];
                this.collections = [];
                this.loading = false;
                return;
            }

            let payload = response.data && response.data.data ? response.data.data : response.data || {};
            this.stats = payload;
            this.accessScope = this.text(payload.accessScope);
            this.books = this.cleanBooks(payload.books || []);
            this.collections = this.cleanCollections(payload.collections || []);
        } catch (error) {
            this.errorMessage = "";
            this.books = [];
            this.collections = [];
        }

        this.loading = false;
    }

    public async fetchMainBooks(): Promise<any> {
        let response = await fetch("/wiz/api/page.main/books", {
            method: "GET",
            credentials: "same-origin",
        });
        let data = {};
        try {
            data = await response.json();
        } catch (error) {
            data = {};
        }
        if (typeof (data as any).code === "number") return data;
        return { code: response.status, data };
    }

    public async withTimeout(promise: Promise<any>, timeoutMs: number): Promise<any> {
        return await Promise.race([
            promise,
            new Promise((_, reject) => setTimeout(() => reject(new Error("timeout")), timeoutMs)),
        ]);
    }

    public responseMessage(response: any, fallback: string): string {
        let data = response?.data;
        if (typeof data === "string") return data;
        if (data?.message) return data.message;
        return fallback;
    }

    public coverImageFromItem(item: any): string {
        let candidates = [
            item?.coverImage,
            item?.cover,
            item?.cover_url,
            item?.coverUrl,
            item?.coverImageUrl,
            item?.cover_image,
            item?.image,
            item?.thumbnail,
            item?.thumbnail_url,
            item?.thumbnailUrl,
            item?.localCoverPath,
            item?.coverPath,
        ];
        return candidates
            .map((value) => this.normalizeCoverUrl(value))
            .find((value) => this.isRealCoverCandidate(value)) || "";
    }

    public coverFallbackFromItem(item: any): string {
        let candidates = [
            item?.coverOriginalUrl,
            item?.cover_original_url,
            item?.originalCoverUrl,
            item?.thumbnailOriginalUrl,
            item?.["표지 원본 URL"],
        ];
        return candidates
            .map((value) => this.normalizeCoverUrl(value))
            .find((value) => this.isRealCoverCandidate(value)) || "";
    }

    public normalizeCoverUrl(value: any): string {
        let url = this.text(value);
        if (!url) return "";
        if (url.startsWith("/wiz/api/page.main/cover?")) {
            return url.replace("/wiz/api/page.main/cover?", "/wiz/api/page.main/cover_image?");
        }
        if (url.startsWith("http://image.aladin.co.kr/")) {
            return url.replace("http://image.aladin.co.kr/", "https://image.aladin.co.kr/");
        }
        return url;
    }

    public isRealCoverCandidate(value: string): boolean {
        if (!value || value === this.fallbackCoverLogoSrc) return false;
        let normalized = value.toLowerCase();
        return !normalized.includes("placeholder") && !normalized.includes("no-cover") && !normalized.includes("no%20cover");
    }

    public cleanBooks(items: any[]): HomeBook[] {
        if (!Array.isArray(items)) return [];
        return items
            .map((item: any, index: number) => {
                let pdfs = Array.isArray(item.pdfs) ? item.pdfs : [];
                let tags = Array.isArray(item.tags) ? item.tags : [];
                let coverImage = this.coverImageFromItem(item);
                let coverFallbackImage = this.coverFallbackFromItem(item);
                if (!coverImage) coverImage = coverFallbackImage;
                return {
                    id: this.text(item.id || item.hflibId || `book-${index}`),
                    hflibId: this.text(item.hflibId),
                    title: this.text(item.title),
                    author: this.text(item.author || "저자·편찬기관 정보 없음"),
                    publisher: this.text(item.publisher || "발행기관 정보 없음"),
                    publishedDate: this.text(item.publishedDate || "발행연도 미상"),
                    publishedYear: Number(item.publishedYear || this.yearFromText(item.publishedDate) || 0),
                    category: this.text(item.category),
                    materialType: this.text(item.materialType || item.bibliographicType || item.category),
                    coverImage: coverImage,
                    coverFallbackImage: coverFallbackImage && coverFallbackImage !== coverImage ? coverFallbackImage : "",
                    coverAvailable: Boolean(coverImage),
                    pdfAvailable: Boolean(item.pdfAvailable || pdfs.length > 0),
                    bodySearchAvailable: Boolean(item.bodySearchAvailable),
                    graphAvailable: Boolean(item.graphAvailable),
                    bodyChunkCount: Number(item.bodyChunkCount || 0),
                    pdfCount: Number(item.pdfCount || pdfs.length || 0),
                    tags: tags.map((tag: any) => ({
                        name: this.text(tag.name),
                        axis: this.text(tag.axis),
                    })).filter((tag: HomeTag) => tag.name).slice(0, 12),
                    publicStatus: this.text(item.publicStatus || "내부전용"),
                    reviewStatus: this.text(item.reviewStatus || "검수대기"),
                    pdfs: pdfs.map((pdf: any) => ({
                        filename: this.text(pdf.filename),
                        url: this.text(pdf.url),
                    })).filter((pdf: HomePdf) => pdf.filename),
                };
            })
            .filter((item: HomeBook) => item.title);
    }

    public cleanCollections(items: any[]): HomeCollection[] {
        if (!Array.isArray(items)) return [];
        return items
            .map((item: any) => ({
                id: this.text(item.id),
                title: this.text(item.title),
                description: this.text(item.description),
                materialCount: Number(item.materialCount || 0),
                pdfCount: Number(item.pdfCount || 0),
                bodyIndexedCount: Number(item.bodyIndexedCount || 0),
                reviewStatus: this.text(item.reviewStatus || "검수대기"),
                publicStatus: this.text(item.publicStatus || "내부전용"),
            }))
            .filter((item: HomeCollection) => item.id && item.title);
    }

    public topNav(): HomeNavItem[] {
        let collection = this.primaryCollection();
        return [
            { id: "search", label: "자료검색", href: "/main?tab=search" },
            { id: "topics", label: "주제탐색", href: "#topics" },
            { id: "reader", label: "원문 열람", href: this.originalsUrl() },
            { id: "graph", label: "자료 관계도 보기", href: this.graphUrl(collection) },
            { id: "ai", label: "이 자료로 질문하기", href: "/main?tab=ai" },
            { id: "books", label: "자료 목록", href: this.allMaterialsUrl() },
        ];
    }

    public fallbackCollections(): HomeCollection[] {
        return [
            {
                id: "dokdo",
                title: "독도",
                description: "독도 영유권과 동해 표기 자료",
                materialCount: 0,
                pdfCount: 0,
                bodyIndexedCount: 0,
                reviewStatus: "검수대기",
                publicStatus: "내부전용",
            },
            {
                id: "balhae",
                title: "발해",
                description: "발해와 유적·고고학 자료",
                materialCount: 0,
                pdfCount: 0,
                bodyIndexedCount: 0,
                reviewStatus: "검수대기",
                publicStatus: "내부전용",
            },
            {
                id: "goguryeo",
                title: "고구려",
                description: "고구려와 유적·비문 자료",
                materialCount: 0,
                pdfCount: 0,
                bodyIndexedCount: 0,
                reviewStatus: "검수대기",
                publicStatus: "내부전용",
            },
            {
                id: "northeast-project",
                title: "동북공정",
                description: "중국 역사서술 쟁점 자료",
                materialCount: 0,
                pdfCount: 0,
                bodyIndexedCount: 0,
                reviewStatus: "검수대기",
                publicStatus: "내부전용",
            },
            {
                id: "japanese-intrusion",
                title: "일제침탈",
                description: "식민지 지배와 침탈 자료",
                materialCount: 0,
                pdfCount: 0,
                bodyIndexedCount: 0,
                reviewStatus: "검수대기",
                publicStatus: "내부전용",
            },
            {
                id: "comfort-women",
                title: "위안부",
                description: "위안부 관련 자료",
                materialCount: 0,
                pdfCount: 0,
                bodyIndexedCount: 0,
                reviewStatus: "검수대기",
                publicStatus: "내부전용",
            },
            {
                id: "korea-japan-talks",
                title: "한일회담",
                description: "한일회담과 청구권 자료",
                materialCount: 0,
                pdfCount: 0,
                bodyIndexedCount: 0,
                reviewStatus: "검수대기",
                publicStatus: "내부전용",
            },
            {
                id: "gando-border",
                title: "간도",
                description: "간도와 국경 인식 자료",
                materialCount: 0,
                pdfCount: 0,
                bodyIndexedCount: 0,
                reviewStatus: "검수대기",
                publicStatus: "내부전용",
            },
        ];
    }

    public displayCollections(): HomeCollection[] {
        let source = this.collections.length ? this.collections : this.fallbackCollections();
        let fallback = this.fallbackCollections();
        let rowsById: any = {};
        [...fallback, ...source].forEach((collection) => rowsById[collection.id] = collection);
        return COLLECTION_ORDER
            .map((id) => rowsById[id])
            .filter((collection) => !!collection)
            .slice(0, 8);
    }

    public primaryCollection(): HomeCollection {
        return this.collections.find((collection) => collection.id === "dokdo")
            || this.collections[0]
            || this.fallbackCollections()[0];
    }

    public recentBooks(): HomeBook[] {
        return this.books
            .slice()
            .sort((a, b) => Number(b.publishedYear || 0) - Number(a.publishedYear || 0) || this.bookReadinessScore(b) - this.bookReadinessScore(a) || a.title.localeCompare(b.title, "ko"))
            .slice(0, RECENT_BOOK_LIMIT);
    }

    public originalPreviewBooks(): HomeBook[] {
        let rows = this.books.filter((book) => book.pdfAvailable);
        if (!rows.length) rows = this.books;
        return rows.slice(0, 4);
    }

    public graphPreviewBooks(): HomeBook[] {
        let rows = this.books.filter((book) => book.graphAvailable || book.bodySearchAvailable || book.bodyChunkCount > 0);
        if (!rows.length) rows = this.books;
        return rows.slice(0, 4);
    }

    public recommendedBooks(): HomeBook[] {
        let rows = this.books
            .slice()
            .sort((a, b) => this.featuredBookBaseScore(b) - this.featuredBookBaseScore(a) || a.title.localeCompare(b.title, "ko"));
        let selected: HomeBook[] = [];
        let selectedIds = new Set<string>();
        let topicCounts: any = {};

        let addBook = (book: HomeBook, topicId: string = ""): boolean => {
            let key = this.bookIdentity(book);
            if (!key || selectedIds.has(key) || selected.length >= FEATURED_BOOK_LIMIT) return false;
            selected.push(book);
            selectedIds.add(key);
            if (topicId) topicCounts[topicId] = Number(topicCounts[topicId] || 0) + 1;
            return true;
        };

        FEATURED_TARGET_TOPICS.forEach((topic) => {
            let topicRows = this.featuredTopicBooks(rows, topic);
            if (topicRows.length) addBook(topicRows[0], topic.id);
        });

        let topicCandidates: Array<{ book: HomeBook, topic: FeaturedTopic, score: number }> = [];
        FEATURED_TARGET_TOPICS.forEach((topic) => {
            this.featuredTopicBooks(rows, topic).forEach((book) => {
                if (!selectedIds.has(this.bookIdentity(book))) {
                    topicCandidates.push({
                        book,
                        topic,
                        score: this.featuredCandidateScore(book, this.featuredTopicScore(book, topic)),
                    });
                }
            });
        });

        topicCandidates
            .sort((a, b) => Number(topicCounts[a.topic.id] || 0) - Number(topicCounts[b.topic.id] || 0) || b.score - a.score || a.book.title.localeCompare(b.book.title, "ko"))
            .forEach((row) => {
                if (selected.length >= FEATURED_BOOK_LIMIT) return;
                if (Number(topicCounts[row.topic.id] || 0) >= 2) return;
                addBook(row.book, row.topic.id);
            });

        rows.forEach((book) => addBook(book));
        return selected.slice(0, FEATURED_BOOK_LIMIT);
    }

    public featuredCollections(): HomeCollection[] {
        return this.displayCollections().slice(0, 4);
    }

    public featuredTitle(): string {
        return this.recommendedBooks().length ? "대표 자료" : "주제별 자료";
    }

    public recentTitle(): string {
        return this.recentBooks().length ? "최근 발행 자료" : "주요 주제";
    }

    public bookReadinessScore(book: HomeBook): number {
        let score = 0;
        if (book.pdfAvailable) score += 20;
        if (book.bodySearchAvailable) score += 28;
        if (book.graphAvailable) score += 24;
        score += Math.min(book.bodyChunkCount, 200) / 10;
        score += Math.min(book.tags.length, 8) * 2;
        if (book.publicStatus.includes("공개가능") || book.publicStatus.includes("공개 가능")) score += 5;
        return score;
    }

    private featuredTopicBooks(rows: HomeBook[], topic: FeaturedTopic): HomeBook[] {
        return rows
            .map((book) => ({ book, score: this.featuredTopicScore(book, topic) }))
            .filter((row) => row.score > 0)
            .sort((a, b) => this.featuredCandidateScore(b.book, b.score) - this.featuredCandidateScore(a.book, a.score) || a.book.title.localeCompare(b.book.title, "ko"))
            .map((row) => row.book);
    }

    private featuredTopicScore(book: HomeBook, topic: FeaturedTopic): number {
        let title = this.text(book.title).toLocaleLowerCase();
        let tags = book.tags.map((tag) => this.text(`${tag.name} ${tag.axis}`).toLocaleLowerCase()).join(" ");
        let haystack = this.featuredBookText(book);
        let score = 0;
        topic.keywords.forEach((keyword) => {
            let key = this.text(keyword).toLocaleLowerCase();
            if (!key) return;
            if (title.includes(key)) score += 28;
            if (tags.includes(key)) score += 18;
            if (haystack.includes(key)) score += 8;
        });
        if (tags.includes(topic.label.toLocaleLowerCase())) score += 20;
        return score;
    }

    private featuredBookBaseScore(book: HomeBook): number {
        let score = this.bookReadinessScore(book);
        if (book.coverAvailable) score += 110;
        if (book.pdfAvailable) score += 80;
        if (book.bodySearchAvailable) score += 45;
        if (book.graphAvailable) score += 45;
        score += Math.min(book.pdfCount, 4) * 4;
        score += Math.min(book.bodyChunkCount, 300) / 12;
        score += Number(book.publishedYear || 0) / 10000;
        return score;
    }

    private featuredCandidateScore(book: HomeBook, topicScore: number = 0): number {
        let score = 0;
        if (book.coverAvailable) score += 100000;
        if (book.pdfAvailable) score += 50000;
        if (book.bodySearchAvailable || book.graphAvailable) score += 25000;
        score += topicScore * 100;
        score += this.featuredBookBaseScore(book);
        return score;
    }

    private featuredBookText(book: HomeBook): string {
        let tagText = book.tags.map((tag) => `${tag.name} ${tag.axis}`).join(" ");
        return [
            book.title,
            book.author,
            book.publisher,
            book.category,
            book.materialType,
            tagText,
            book.publicStatus,
            book.reviewStatus,
        ].map((value) => this.text(value).toLocaleLowerCase()).join(" ");
    }

    private bookIdentity(book: HomeBook): string {
        return this.text(book.id || book.hflibId || book.title);
    }

    public metricRows(): HomeMetric[] {
        if (this.loading && !this.books.length) {
            return [
                { label: "자료", value: "...", note: "자료 요약 불러오는 중", tone: "cream" },
                { label: "원문", value: "...", note: "원문 열람 가능 여부 확인 중", tone: "beige" },
                { label: "본문 검색", value: "...", note: "본문 검색 상태 확인 중", tone: "clay" },
                { label: "자료 관계도", value: "...", note: "연결 정보 확인 중", tone: "charcoal" },
            ];
        }
        if (this.overviewUnavailable()) {
            return [
                { label: "자료", value: "-", note: "자료검색에서 확인", tone: "cream" },
                { label: "원문", value: "-", note: "원문 열람 가능 자료로 이동", tone: "beige" },
                { label: "본문 검색", value: "-", note: "검색 화면에서 확인", tone: "clay" },
                { label: "자료 관계도", value: "-", note: "주제별 관계도로 이동", tone: "charcoal" },
            ];
        }
        let total = Number(this.stats.count || this.books.length || 0);
        let pdfReady = this.books.filter((book) => book.pdfAvailable).length;
        let bodyReady = this.books.filter((book) => book.bodySearchAvailable).length;
        let graphReady = this.books.filter((book) => book.graphAvailable).length;
        return [
            { label: "자료", value: `${total}건`, note: this.accessScope === "public" ? "공개 자료 범위" : "찾아볼 수 있는 자료", tone: "cream" },
            { label: "원문", value: `${pdfReady}건`, note: "원문 열람 가능", tone: "beige" },
            { label: "본문 검색", value: `${bodyReady}건`, note: "본문까지 찾기 가능", tone: "clay" },
            { label: "자료 관계도", value: `${graphReady}건`, note: "인물·장소·사건 연결", tone: "charcoal" },
        ];
    }

    public entryCards(): HomeEntry[] {
        let collection = this.primaryCollection();
        let graphReady = this.books.filter((book) => book.graphAvailable).length;
        let pdfReady = this.books.filter((book) => book.pdfAvailable).length;
        let loadingStat = this.loading && !this.books.length ? "불러오는 중" : "";
        let fallbackStat = this.overviewUnavailable() ? "자료검색" : "";
        return [
            {
                id: "search",
                icon: "fa-solid fa-magnifying-glass",
                label: "검색",
                title: "자료검색",
                body: "제목, 주제, 본문까지 함께 찾습니다.",
                href: "/main?tab=search",
                stat: "검색 시작",
                tone: "cream",
            },
            {
                id: "collections",
                icon: "fa-solid fa-layer-group",
                label: "주제",
                title: "주제탐색",
                body: "주요 역사현안별 자료 묶음을 봅니다.",
                href: this.collectionUrl(collection),
                stat: loadingStat || `${this.displayCollections().length}개 주제`,
                tone: "olive",
            },
            {
                id: "reader",
                icon: "fa-solid fa-book-open-reader",
                label: "원문",
                title: "원문 열람 자료",
                body: "원문을 바로 볼 수 있는 자료를 먼저 봅니다.",
                href: this.originalsUrl(),
                stat: loadingStat || fallbackStat || (pdfReady ? `${pdfReady}건` : "자료 검색"),
                tone: "beige",
            },
            {
                id: "graph",
                icon: "fa-solid fa-diagram-project",
                label: "연결",
                title: "자료 관계도 보기",
                body: "자료와 인물·장소·주제가 어떻게 이어지는지 봅니다.",
                href: this.graphUrl(collection),
                stat: loadingStat || fallbackStat || (graphReady ? `${graphReady}건` : "그래프 열기"),
                tone: "charcoal",
            },
            {
                id: "ai",
                icon: "fa-solid fa-comments",
                label: "질문",
                title: "이 자료로 질문하기",
                body: "자료 범위와 근거를 확인하며 질문합니다.",
                href: "/main?tab=ai",
                stat: "질문 열기",
                tone: "clay",
            },
            {
                id: "books",
                icon: "fa-solid fa-list-ul",
                label: "목록",
                title: "전체 자료 보기",
                body: "자료 목록에서 원하는 책을 살펴봅니다.",
                href: this.allMaterialsUrl(),
                stat: loadingStat || fallbackStat || `${this.books.length}건`,
                tone: "bluegrey",
            },
        ];
    }

    public overviewUnavailable(): boolean {
        return !this.loading && !this.books.length && !Number(this.stats.count || 0);
    }

    public searchEntryCards(): HomeEntry[] {
        return this.entryCards();
    }

    public quickTopics(): Array<{ label: string, query: string, collectionId: string }> {
        return [
            { label: "독도", query: "독도", collectionId: "dokdo" },
            { label: "발해", query: "발해", collectionId: "balhae" },
            { label: "고구려", query: "고구려", collectionId: "goguryeo" },
            { label: "한일회담", query: "한일회담", collectionId: "korea-japan-talks" },
            { label: "일제침탈", query: "일제침탈", collectionId: "japanese-intrusion" },
            { label: "위안부", query: "위안부", collectionId: "comfort-women" },
            { label: "동북공정", query: "동북공정", collectionId: "northeast-project" },
        ];
    }

    public submitSearch(event?: Event) {
        if (event) event.preventDefault();
        let query = this.text(this.searchQuery);
        this.service.href(query ? `/main?tab=search&q=${encodeURIComponent(query)}` : "/main?tab=search");
    }

    public searchUrl(query: string): string {
        query = this.text(query);
        return query ? `/main?tab=search&q=${encodeURIComponent(query)}` : "/main?tab=search";
    }

    public collectionUrl(collection: HomeCollection): string {
        let id = encodeURIComponent(collection?.id || this.primaryCollection().id);
        return `/main?tab=search&collection=${id}`;
    }

    public graphUrl(collection: HomeCollection): string {
        let id = encodeURIComponent(collection?.id || this.primaryCollection().id);
        return `/main?tab=graph&graph=collection&collection=${id}`;
    }

    public allMaterialsUrl(): string {
        return "/main?tab=books";
    }

    public originalsUrl(): string {
        return "/main?tab=search&pdf=with-pdf&sort=pdf";
    }

    public materialUrl(book: HomeBook): string {
        let id = encodeURIComponent(book?.id || book?.hflibId || "");
        return id ? `/main/${id}` : "/main";
    }

    public originalActionUrl(book: HomeBook): string {
        return book?.pdfAvailable ? `${this.materialUrl(book)}#ebook-reader` : this.materialUrl(book);
    }

    public bodySearchActionUrl(book: HomeBook): string {
        return `${this.materialUrl(book)}#body-search`;
    }

    public bookGraphUrl(book: HomeBook): string {
        let id = encodeURIComponent(book?.id || book?.hflibId || "");
        return id ? `/main?tab=graph&graph=book&bookId=${id}` : this.graphUrl(this.primaryCollection());
    }

    public topicActionUrl(book: HomeBook): string {
        let topic = this.primaryTopic(book);
        return topic ? this.searchUrl(topic) : this.materialUrl(book);
    }

    public primaryTopic(book: HomeBook): string {
        return this.axisTagNames(book, TAG_AXES.issue)[0]
            || this.axisTagNames(book, TAG_AXES.business)[0]
            || this.axisTagNames(book, TAG_AXES.relation)[0]
            || this.axisTagNames(book, TAG_AXES.region)[0]
            || this.axisTagNames(book, TAG_AXES.era)[0]
            || this.uniqueOptions(book.tags.map((tag) => tag.name))[0]
            || "";
    }

    public collectionMeta(collection: HomeCollection): string {
        if (collection.materialCount || collection.pdfCount || collection.bodyIndexedCount) {
            return `자료 ${collection.materialCount}건 · 원문 ${collection.pdfCount}개 · 본문 ${collection.bodyIndexedCount}건`;
        }
        return "주제별 자료";
    }

    public collectionStats(collection: HomeCollection): HomeCollectionStat[] {
        return [
            { label: "자료", value: `${Number(collection?.materialCount || 0)}건` },
            { label: "원문", value: `${Number(collection?.pdfCount || 0)}개` },
            { label: "본문", value: `${Number(collection?.bodyIndexedCount || 0)}건` },
        ];
    }

    public collectionDisplayTitle(collection: HomeCollection): string {
        return COLLECTION_TITLES[collection?.id] || collection?.title || "";
    }

    public collectionDisplayDescription(collection: HomeCollection): string {
        return COLLECTION_DESCRIPTIONS[collection?.id] || collection?.description || "";
    }

    public collectionToneClass(collection: HomeCollection): string {
        let id = this.text(collection?.id).toLowerCase().replace(/[^a-z0-9-]/g, "-");
        return id ? `topic-${id}` : "topic-default";
    }

    public materialMeta(book: HomeBook): string {
        let year = book.publishedYear ? `${book.publishedYear}` : book.publishedDate;
        return `${year} · ${book.publisher}`;
    }

    public materialYear(book: HomeBook): string {
        return book.publishedYear ? `${book.publishedYear}` : this.text(book.publishedDate || "연도 미상");
    }

    public materialPublisher(book: HomeBook): string {
        return this.text(book.publisher || "발행기관 정보 없음");
    }

    public materialNature(book: HomeBook): string {
        return this.axisTagNames(book, TAG_AXES.material)[0]
            || this.text(book.materialType)
            || this.text(book.category)
            || "자료";
    }

    public coverTypeLabel(book: HomeBook): string {
        return this.textPreview(this.materialNature(book), 10);
    }

    public coverTitlePreview(book: HomeBook): string {
        return this.textPreview(book.title, 34);
    }

    public coverMetaLine(book: HomeBook): string {
        return this.textPreview(this.materialYear(book) || "발행연도 미상", 16);
    }

    public bookFeatureBadges(book: HomeBook): string[] {
        let badges = [];
        if (book.pdfAvailable) badges.push("원문");
        if (book.bodySearchAvailable) badges.push("본문 검색");
        if (book.graphAvailable) badges.push("자료 관계도");
        if (book.tags.length) badges.push("주제어");
        if (!badges.length) badges.push("자료 보기");
        return badges.slice(0, 4);
    }

    public fieldBundles(): HomeFieldBundle[] {
        let axes = [TAG_AXES.issue, TAG_AXES.business, TAG_AXES.material, TAG_AXES.era, TAG_AXES.region, TAG_AXES.purpose];
        let bundles: HomeFieldBundle[] = [];
        axes.forEach((axis) => {
            let counts: any = {};
            this.books.forEach((book) => {
                this.axisTagNames(book, axis).forEach((name) => counts[name] = (counts[name] || 0) + 1);
            });
            let top = Object.keys(counts)
                .sort((a, b) => counts[b] - counts[a] || a.localeCompare(b, "ko"))
                .slice(0, 4);
            if (!top.length) return;
            bundles.push({
                id: axis,
                axisLabel: this.axisLabel(axis),
                title: top[0],
                count: top.reduce((sum, tag) => sum + counts[tag], 0),
                tags: top,
                href: this.searchUrl(top[0]),
            });
        });

        if (bundles.length) return bundles.slice(0, 6);

        return [
            { id: "fallback-dokdo", axisLabel: "역사현안", title: "독도·동해", count: 0, tags: ["독도", "동해", "영토·영유권"], href: this.searchUrl("독도") },
            { id: "fallback-japan", axisLabel: "역사현안", title: "한일 역사문제", count: 0, tags: ["일제침탈", "위안부", "한일회담"], href: this.searchUrl("일제침탈") },
            { id: "fallback-goguryeo", axisLabel: "공식 사업", title: "한국 고중세사", count: 0, tags: ["고구려", "발해", "동북공정"], href: this.searchUrl("고구려") },
            { id: "fallback-education", axisLabel: "업무 목적", title: "교육자료", count: 0, tags: ["교육자료", "대중해설", "다국어"], href: this.searchUrl("교육자료") },
        ];
    }

    public detailFlowSteps(): HomeFlowStep[] {
        let book = this.recommendedBooks()[0] || this.recentBooks()[0] || null;
        let collection = this.primaryCollection();
        return [
            { id: "cards", label: "자료 목록", meta: `${this.books.length}건`, href: "/main?tab=books", icon: "fa-solid fa-table-cells-large" },
            { id: "detail", label: "상세 정보", meta: "자료 기본정보", href: book ? this.materialUrl(book) : "/main", icon: "fa-solid fa-circle-info" },
            { id: "reader", label: "원문 열람", meta: "원문 보기", href: this.originalsUrl(), icon: "fa-solid fa-book-open" },
            { id: "graph", label: "자료 관계도", meta: this.collectionDisplayTitle(collection), href: this.graphUrl(collection), icon: "fa-solid fa-diagram-project" },
        ];
    }

    public axisTagNames(book: HomeBook, axis: string): string[] {
        return this.uniqueOptions(book.tags.filter((tag) => tag.axis === axis).map((tag) => tag.name));
    }

    public axisLabel(axis: string): string {
        return AXIS_LABELS[axis] || axis.replace(/\s*축$/, "");
    }

    public uniqueOptions(values: string[]): string[] {
        let seen: any = {};
        return values
            .map((value) => this.text(value))
            .filter((value) => {
                if (!value || seen[value]) return false;
                seen[value] = true;
                return true;
            });
    }

    public bookStatusLabel(book: HomeBook): string {
        if (book.bodySearchAvailable) return "본문 검색";
        if (book.pdfAvailable) return "원문 보기";
        if (book.graphAvailable) return "자료 관계도";
        return "자료 보기";
    }

    public currentUserName(): string {
        return this.service.auth.session?.name || this.service.auth.session?.username || "";
    }

    public currentUserRoleLabel(): string {
        let role = this.service.auth.session?.role || "";
        let labels: any = {
            user: "일반 사용자",
            researcher: "연구자",
            materials: "자료관리 담당자",
            reviewer: "검수자",
            admin: "관리자",
        };
        return labels[role] || role || "비로그인";
    }

    public currentUserStatusLabel(): string {
        let status = this.service.auth.session?.status || "";
        let labels: any = {
            pending: "승인대기",
            active: "활성",
            rejected: "반려",
            inactive: "비활성",
        };
        return labels[status] || status || "공개 접근";
    }

    public isAuthenticated(): boolean {
        return !!this.service.auth.status;
    }

    public isAdmin(): boolean {
        return this.service.auth.session?.status === "active" && this.service.auth.session?.role === "admin";
    }

    public materialPermissions(): string[] {
        let value = this.service.auth.session?.materialsPermissions || this.service.auth.session?.materials_permissions || [];
        if (Array.isArray(value)) return value;
        if (typeof value === "string" && value.trim()) {
            try {
                let parsed = JSON.parse(value);
                if (Array.isArray(parsed)) return parsed;
            } catch (e) {
                return value.split(",").map((item) => item.trim()).filter((item) => !!item);
            }
        }
        return [];
    }

    public canAccessMaterials(): boolean {
        let session = this.service.auth.session || {};
        return session.status === "active" && (["admin", "materials"].includes(session.role) || this.materialPermissions().length > 0);
    }

    public coverAlt(book: HomeBook): string {
        return book.coverAvailable ? `${book.title} 표지` : "표지 이미지 없음";
    }

    public markCoverMissing(book: HomeBook, event?: Event) {
        if (book.coverFallbackImage && book.coverFallbackImage !== book.coverImage) {
            book.coverImage = book.coverFallbackImage;
            book.coverFallbackImage = "";
            book.coverAvailable = true;
            let target = event?.target as HTMLImageElement;
            if (target) target.src = book.coverImage;
            return;
        }
        book.coverAvailable = false;
        book.coverImage = "";
        let target = event?.target as HTMLImageElement;
        if (target) target.removeAttribute("src");
    }

    public text(value: any): string {
        if (value === null || value === undefined) return "";
        return String(value).trim();
    }

    public textPreview(value: any, limit: number): string {
        let text = this.text(value).replace(/\s+/g, " ");
        if (!text || text.length <= limit) return text;
        return `${text.slice(0, limit).trim()}...`;
    }

    public yearFromText(value: any): number {
        let match = this.text(value).match(/(18|19|20)\d{2}/);
        return match ? Number(match[0]) : 0;
    }

    public trackMetric(index: number, item: HomeMetric) {
        return item.label || index;
    }

    public trackEntry(index: number, item: HomeEntry) {
        return item.id || index;
    }

    public trackCollection(index: number, item: HomeCollection) {
        return item.id || index;
    }

    public trackCollectionStat(index: number, item: HomeCollectionStat) {
        return `${item.label}-${item.value}` || index;
    }

    public trackBook(index: number, item: HomeBook) {
        return item.id || index;
    }

    public trackTopic(index: number, item: any) {
        return item.label || index;
    }

    public trackTag(index: number, item: HomeTag) {
        return item.name || index;
    }

    public trackNav(index: number, item: HomeNavItem) {
        return item.id || index;
    }

    public trackBundle(index: number, item: HomeFieldBundle) {
        return item.id || index;
    }

    public trackFlow(index: number, item: HomeFlowStep) {
        return item.id || index;
    }

    public trackText(index: number, item: string) {
        return item || index;
    }
}

export default PageHomeComponent;